import {
  ImageIcon,
  Video,
  Music,
  FileText,
  Archive,
  MoreHorizontal,
} from "lucide-react";

import blog1 from "../assets/blog-1.jpg";
import blog2 from "../assets/blog-2.jpg";
import blog3 from "../assets/blog-3.jpg";
import blog4 from "../assets/blog-4.jpg";
import blog5 from "../assets/blog-5.jpg";
import blog6 from "../assets/blog-6.jpg";
import blog7 from "../assets/blog-7.jpg";
import blog8 from "../assets/blog-8.jpg";
import blog9 from "../assets/blog-9.jpg";
import blog10 from "../assets/blog-10.jpg";
import blog11 from "../assets/blog-11.png";
import blog12 from "../assets/blog-12.jpg";
import blog13 from "../assets/blog-13.jpg";
import blog14 from "../assets/blog-14.jpg";
import blog15 from "../assets/blog-15.png";
import blog16 from "../assets/blog-16.jpg";
import blog17 from "../assets/blog-17.jpg";
import blog18 from "../assets/blog-18.jpg";
import blog19 from "../assets/blog-19.jpg";
import blog20 from "../assets/blog-20.jpg";
import blog21 from "../assets/blog-21.png";
import blog22 from "../assets/blog-22.jpg";
import blog23 from "../assets/blog-23.jpg";
import blog24 from "../assets/blog-24.jpg";

export const allBlogs = [
  {
    id: 1,
    title: "Convert JPG to PNG — 3 Quick and Easy Methods",
    description:
      "Convert JPG to PNG easily with three simple methods. Try our free online converter for instant results, or use desktop tools and online platforms for quick conversion.",
    author: "Vishal Dhanotiya",
    date: "October 8, 2025",
    image: blog1,
    category: "Image",
    path: "/how-to-convert-image-from-jpg-to-png",
  },
  {
    id: 2,
    title: "How to Use Sample Files in Software Testing",
    description:
      "Learn how sample files improve software testing. Explore QA workflows, testing web apps, media players, and discover best practices for reliable testing.",
    author: "John Doe",
    date: "September 20, 2025",
    image: blog2,
    category: "Testing",
    path: "/how-to-use-sample-files-for-testing",
  },
  {
    id: 3,
    title: "PNG vs WebP vs 9-Patch: Which Image Format Wins?",
    description:
      "Compare PNG, WebP, and 9-Patch image formats to find the best choice for web and mobile performance. Learn compression, quality, and optimization tips.",
    author: "Vishal Dhanotiya",
    date: "August 14, 2025",
    image: blog3,
    category: "Image",
    path: "/compare-png-webp-and-nine-patch-images",
  },
  {
    id: 4,
    title: "Image Optimization — A Complete Guide for Speed",
    description:
      "Complete guide to image optimization for faster websites. Learn WebP, AVIF, compression techniques, and Core Web Vitals best practices for better performance.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog4,
    category: "Image",
    path: "/image-optimization-best-practices-for-web-performance",
  },
  {
    id: 5,
    title: "File Upload Security Best Practices for Developers",
    description:
      "Master secure file upload practices for developers. Learn client/server validation, allowed file types, malware scanning, and protect web applications.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog5,
    category: "Security",
    path: "/file-upload-security-a-complete-guide-for-developers",
  },
  {
    id: 6,
    title:
      "The PNG Paradox: Fixing Common Transparency, File Size, and Quality Mistakes",
    description:
      "Fix common PNG problems: transparency glitches, large file sizes, and quality loss. Learn effective solutions and optimization techniques for better results.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog6,
    category: "Image",
    path: "/the-png-paradox-fixing-common-transparency-file-size-and-quality-mistakes",
  },
  {
    id: 7,
    title:
      "AVIF: The Next-Generation Image Format Revolutionizing Web Performance",
    description:
      "Discover AVIF image format: the future of web performance. Learn how it outperforms WebP and JPEG with superior compression, better quality, and bandwidth savings.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog7,
    category: "Image",
    path: "/avif-the-next-generation-image-format-revolutionizing-web-performance",
  },
  {
    id: 8,
    title: "3 File Types Hackers Use to Spread Malware",
    description:
      "Learn which file types (.EXE, .DOCM, .ZIP) hackers use to spread malware. Discover how attackers exploit these formats and how to protect your devices.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog8,
    category: "Security",
    path: "/three-file-types-you-should-never-open-from-a-stranger",
    //path: "/dangerous-file-types-hackers-use",
  },
  {
    id: 9,
    title: "PDF vs DOCX: Which Document Format Is Better?",
    description:
      "Compare PDF and DOCX formats: pros, cons, and best use cases. Learn when to choose PDF for distribution or DOCX for editing to boost productivity.",
    author: "Vishal Dhanotiya",
    date: "October 27, 2025",
    image: blog9,
    category: "Document",
    path: "/pdf-vs-docx-what-is-the-difference-and-when-to-use-each",
  },
  {
    id: 10,
    title: "JSON Explained: The Developer's Favorite Data Format",
    description:
      "Understand why JSON is the developer's favorite data format. Learn its simplicity, advantages over XML, and why APIs and web services prefer JSON for data exchange.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog10,
    category: "Code",
    path: "/why-developers-everyone-love-json-format-data",
  },
  {
    id: 11,
    title: "Master PDF Editing: Best Tools, Tips, and Tricks",
    description:
      "Master PDF editing with the best tools and techniques. Learn how to edit, merge, split, and secure PDFs. Discover free and paid editors for every need.",
    author: "Vishal Dhanotiya",
    date: "October 31, 2025",
    image: blog11,
    category: "Document",
    path: "/mastering-pdf-editing-the-ultimate-guide-to-tools-tips-and-tricks",
  },
  {
    id: 12,
    title: "PNG Optimization Guide for Faster Websites",
    description:
      "PNG optimization guide for faster websites. Learn compression techniques, quality settings, and best practices to speed up your site while maintaining PNG quality.",
    author: "Vishal Dhanotiya",
    date: "November 2, 2025",
    image: blog12,
    category: "Image",
    path: "/why-your-pngs-are-secretly-slowing-down-your-site-and-how-to-fix-it",
  },
  {
    id: 13,
    title: "When to Use JPG: Pros, Cons, and Use Cases",
    description:
      "Master when to use JPG format. Discover pros, cons, compression techniques, and perfect use cases for photography, web performance, and digital images.",
    author: "Vishal Dhanotiya",
    date: "November 3, 2025",
    image: blog13,
    category: "Image",
    path: "/the-ultimate-jpg-guide-photos-compression-and-web-performance-explained",
  },
  {
    id: 14,
    title: "Learn WebP Format: Save Bandwidth and Boost Speed",
    description:
      "Learn how WebP format saves bandwidth and boosts page speed. Discover modern compression technology, implementation tips, and fallback strategies.",
    author: "Vishal Dhanotiya",
    date: "November 4, 2025",
    image: blog14,
    category: "Image",
    path: "/webp-the-modern-image-format-thats-changing-the-web",
  },
  {
    id: 15,
    title: "GIF Format: Still Popular or Time for an Upgrade?",
    description:
      "Explore GIF format: why it's still popular, limitations, and when to upgrade to MP4 or WebP. Learn optimization and modern animation alternatives.",
    author: "Vishal Dhanotiya",
    date: "November 5, 2025",
    image: blog15,
    category: "Image",
    path: "/gif-files-the-internet-favorite-format-that-refuses-to-die",
  },
  {
    id: 16,
    title: "3GP File Format: Legacy, Uses, and Conversions",
    description:
      "Explore 3GP file format: history, benefits, and conversion guide. Learn why it shaped mobile communication and how to use it in today's digital world.",
    author: "Vishal Dhanotiya",
    date: "November 6, 2025",
    image: blog16,
    category: "Video",
    path: "/3gp-file-format-guide",
  },
  {
    id: 17,
    title: "MP4: The Universal Video Format That Powers Modern Media",
    description:
      "Learn why MP4 dominates video. Understand flexible codecs, streaming capabilities, universal compatibility, and best practices for modern video.",
    author: "Vishal Dhanotiya",
    date: "November 7, 2025",
    image: blog17,
    category: "Video",
    path: "/mp4-video-format-guide",
  },
  {
    id: 18,
    title: "Discover AVI Format: The Classic PC Video Workhorse",
    description:
      "Discover AVI format as the classic PC video workhorse. Explore its legacy, codec limitations, modern compatibility issues, and conversion solutions.",
    author: "Vishal Dhanotiya",
    date: "November 8, 2025",
    image: blog18,
    category: "Video",
    path: "/avi-video-format-guide",
  },
  {
    id: 19,
    title: "MKV Format: Why Video Enthusiasts Love It",
    description:
      "Learn why video enthusiasts love MKV format. Discover its flexibility, subtitles support, open-source advantages, and how to create MKV files.",
    author: "Vishal Dhanotiya",
    date: "November 9, 2025",
    image: blog19,
    category: "Video",
    path: "/mkv-video-format-guide",
  },
  {
    id: 20,
    title: "Master MOV Format: Apple's Professional Video Container",
    description:
      "Master MOV format: Apple's professional video container. Learn ProRes codec advantages, editing flexibility, and high-quality video workflows.",
    author: "Vishal Dhanotiya",
    date: "November 10, 2025",
    image: blog20,
    category: "Video",
    path: "/mov-video-format-guide",
  },
  {
    id: 21,
    title: "WMV Format: Legacy, Compatibility, and Conversion",
    description:
      "Understand WMV format: legacy, compatibility, and conversion guide. Learn its role in early streaming and how to convert for modern devices.",
    author: "Vishal Dhanotiya",
    date: "November 12, 2025",
    image: blog21,
    category: "Video",
    path: "/wmv-video-format-guide",
  },
  {
    id: 22,
    title: "Discover MP3 Format: How Audio Compression Changed Music",
    description:
      "Explore how MP3 revolutionized music with efficient compression and universal playback. Learn audio compression, bitrate trade-offs, and MP3's modern role.",
    author: "Vishal Dhanotiya",
    date: "November 14, 2025",
    image: blog22,
    category: "Audio",
    path: "/mp3-audio-format-guide",
  },
  {
    id: 23,
    title: "AAC: The Audio Format That Powers Your Digital Life",
    description:
      "Understand AAC audio format: the modern MP3 successor. Learn why it delivers better sound efficiency for Spotify, YouTube, Apple Music, and streaming.",
    author: "Vishal Dhanotiya",
    date: "November 16, 2025",
    image: blog23,
    category: "Audio",
    path: "/aac-audio-format-guide",
  },
  {
    id: 24,
    title: "Master FLAC Audio Format: Lossless Sound Explained",
    description:
      "Master FLAC audio format: lossless sound explained. Learn its role in high-resolution audio, comparisons to MP3, and audiophile-quality streaming.",
    author: "Vishal Dhanotiya",
    date: "November 18, 2025",
    image: blog24,
    category: "Audio",
    path: "/flac-audio-format-guide",
  },
];

export const relatedImageBlogs = [
  {
    id: 1,
    title: "Convert JPG to PNG — 3 Quick and Easy Methods",
    description:
      "Convert JPG to PNG easily with three simple methods. Try our free online converter for instant results, or use desktop tools and online platforms for quick conversion.",
    author: "Vishal Dhanotiya",
    date: "October 8, 2025",
    image: blog1,
    category: "Image",
    path: "/how-to-convert-image-from-jpg-to-png",
  },
  {
    id: 2,
    title: "PNG vs WebP vs 9-Patch: Which Image Format Wins?",
    description:
      "Compare PNG, WebP, and 9-Patch image formats to find the best choice for web and mobile performance. Learn compression, quality, and optimization tips.",
    author: "Vishal Dhanotiya",
    date: "August 14, 2025",
    image: blog3,
    category: "Image",
    path: "/compare-png-webp-and-nine-patch-images",
  },
  {
    id: 3,
    title: "Image Optimization — A Complete Guide for Speed",
    description:
      "Complete guide to image optimization for faster websites. Learn WebP, AVIF, compression techniques, and Core Web Vitals best practices for better performance.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog4,
    category: "Image",
    path: "/image-optimization-best-practices-for-web-performance",
  },
  {
    id: 4,
    title:
      "The PNG Paradox: Fixing Common Transparency, File Size, and Quality Mistakes",
    description:
      "Fix common PNG problems: transparency glitches, large file sizes, and quality loss. Learn effective solutions and optimization techniques for better results.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog6,
    category: "Image",
    path: "/the-png-paradox-fixing-common-transparency-file-size-and-quality-mistakes",
  },
  {
    id: 5,
    title:
      "AVIF: The Next-Generation Image Format Revolutionizing Web Performance",
    description:
      "Discover AVIF image format: the future of web performance. Learn how it outperforms WebP and JPEG with superior compression, better quality, and bandwidth savings.",
    author: "Vishal Dhanotiya",
    date: "October 15, 2025",
    image: blog7,
    category: "Image",
    path: "/avif-the-next-generation-image-format-revolutionizing-web-performance",
  },
  {
    id: 6,
    title: "PNG Optimization Guide for Faster Websites",
    description:
      "PNG optimization guide for faster websites. Learn compression techniques, quality settings, and best practices to speed up your site while maintaining PNG quality.",
    author: "Vishal Dhanotiya",
    date: "November 2, 2025",
    image: blog12,
    category: "Image",
    path: "/why-your-pngs-are-secretly-slowing-down-your-site-and-how-to-fix-it",
  },
  {
    id: 7,
    title: "When to Use JPG: Pros, Cons, and Use Cases",
    description:
      "Master when to use JPG format. Discover pros, cons, compression techniques, and perfect use cases for photography, web performance, and digital images.",
    author: "Vishal Dhanotiya",
    date: "November 3, 2025",
    image: blog13,
    category: "Image",
    path: "/the-ultimate-jpg-guide-photos-compression-and-web-performance-explained",
  },
  {
    id: 8,
    title: "Learn WebP Format: Save Bandwidth and Boost Speed",
    description:
      "Learn how WebP format saves bandwidth and boosts page speed. Discover modern compression technology, implementation tips, and fallback strategies.",
    author: "Vishal Dhanotiya",
    date: "November 4, 2025",
    image: blog14,
    category: "Image",
    path: "/webp-the-modern-image-format-thats-changing-the-web",
  },
  {
    id: 9,
    title: "GIF Format: Still Popular or Time for an Upgrade?",
    description:
      "Explore GIF format: why it's still popular, limitations, and when to upgrade to MP4 or WebP. Learn optimization and modern animation alternatives.",
    author: "Vishal Dhanotiya",
    date: "November 5, 2025",
    image: blog15,
    category: "Image",
    path: "/gif-files-the-internet-favorite-format-that-refuses-to-die",
  },
];

export const relatedVideoBlogs = [
  {
    id: 16,
    title: "3GP File Format: Legacy, Uses, and Conversions",
    description:
      "Explore 3GP file format: history, benefits, and conversion guide. Learn why it shaped mobile communication and how to use it in today's digital world.",
    author: "Vishal Dhanotiya",
    date: "November 6, 2025",
    image: blog16,
    category: "Video",
    path: "/3gp-file-format-guide",
  },
  {
    id: 17,
    title: "MP4: The Universal Video Format That Powers Modern Media",
    description:
      "Learn why MP4 dominates video. Understand flexible codecs, streaming capabilities, universal compatibility, and best practices for modern video.",
    author: "Vishal Dhanotiya",
    date: "November 7, 2025",
    image: blog17,
    category: "Video",
    path: "/mp4-video-format-guide",
  },
  {
    id: 18,
    title: "Discover AVI Format: The Classic PC Video Workhorse",
    description:
      "Discover AVI format as the classic PC video workhorse. Explore its legacy, codec limitations, modern compatibility issues, and conversion solutions.",
    author: "Vishal Dhanotiya",
    date: "November 8, 2025",
    image: blog18,
    category: "Video",
    path: "/avi-video-format-guide",
  },
  {
    id: 19,
    title: "MKV Format: Why Video Enthusiasts Love It",
    description:
      "Learn why video enthusiasts love MKV format. Discover its flexibility, subtitles support, open-source advantages, and how to create MKV files.",
    author: "Vishal Dhanotiya",
    date: "November 9, 2025",
    image: blog19,
    category: "Video",
    path: "/mkv-video-format-guide",
  },
  {
    id: 20,
    title: "Master MOV Format: Apple's Professional Video Container",
    description:
      "Master MOV format: Apple's professional video container. Learn ProRes codec advantages, editing flexibility, and high-quality video workflows.",
    author: "Vishal Dhanotiya",
    date: "November 10, 2025",
    image: blog20,
    category: "Video",
    path: "/mov-video-format-guide",
  },
  {
    id: 21,
    title: "WMV Format: Legacy, Compatibility, and Conversion",
    description:
      "Understand WMV format: legacy, compatibility, and conversion guide. Learn its role in early streaming and how to convert for modern devices.",
    author: "Vishal Dhanotiya",
    date: "November 12, 2025",
    image: blog21,
    category: "Video",
    path: "/wmv-video-format-guide",
  },
  
];

export const allAudioBlogs = [
  {
    id: 22,
    title: "Discover MP3 Format: How Audio Compression Changed Music",
    description:
      "Explore how MP3 revolutionized music with efficient compression and universal playback. Learn audio compression, bitrate trade-offs, and MP3's modern role.",
    author: "Vishal Dhanotiya",
    date: "November 14, 2025",
    image: blog22,
    category: "Audio",
    path: "/mp3-audio-format-guide",
  },
  {
    id: 23,
    title: "AAC: The Audio Format That Powers Your Digital Life",
    description:
      "Understand AAC audio format: the modern MP3 successor. Learn why it delivers better sound efficiency for Spotify, YouTube, Apple Music, and streaming.",
    author: "Vishal Dhanotiya",
    date: "November 16, 2025",
    image: blog23,
    category: "Audio",
    path: "/aac-audio-format-guide",
  },
  {
    id: 24,
    title: "Master FLAC Audio Format: Lossless Sound Explained",
    description:
      "Master FLAC audio format: lossless sound explained. Learn its role in high-resolution audio, comparisons to MP3, and audiophile-quality streaming.",
    author: "Vishal Dhanotiya",
    date: "November 18, 2025",
    image: blog24,
    category: "Audio",
    path: "/flac-audio-format-guide",
  },
];

export const relatedDocumentBlogs = [
  {
    id: 9,
    title: "PDF vs DOCX: Which Document Format Is Better?",
    description:
      "Compare PDF and DOCX formats: pros, cons, and best use cases. Learn when to choose PDF for distribution or DOCX for editing to boost productivity.",
    author: "Vishal Dhanotiya",
    date: "October 27, 2025",
    image: blog9,
    category: "Document",
    path: "/pdf-vs-docx-what-is-the-difference-and-when-to-use-each",
  },
  {
    id: 11,
    title: "Master PDF Editing: Best Tools, Tips, and Tricks",
    description:
      "Master PDF editing with the best tools and techniques. Learn how to edit, merge, split, and secure PDFs. Discover free and paid editors for every need.",
    author: "Vishal Dhanotiya",
    date: "October 31, 2025",
    image: blog11,
    category: "Document",
    path: "/mastering-pdf-editing-the-ultimate-guide-to-tools-tips-and-tricks",
  },
];

export const isCloudinaryFiles = false;
export const updatedDatabaseKey = isCloudinaryFiles ? "files" : "r2Files";

export const imageTabData = [
  {
    key: "jpg",
    title: "JPG",
    resourceType: "images",
    path: "/sample-images/jpg",
  },
  {
    key: "png",
    title: "PNG",
    resourceType: "images",
    path: "/sample-images/png",
  },
  {
    key: "webp",
    title: "WEBP",
    resourceType: "images",
    path: "/sample-images/webp",
  },
  {
    key: "svg",
    title: "SVG",
    resourceType: "images",
    path: "/sample-images/svg",
  },
  {
    key: "gif",
    title: "GIF",
    resourceType: "images",
    path: "/sample-images/gif",
  },
  {
    key: "bmp",
    title: "BMP",
    resourceType: "images",
    path: "/sample-images/bmp",
  },
  {
    key: "psd",
    title: "PSD",
    resourceType: "images",
    path: "/sample-images/psd",
  },
  {
    key: "tiff",
    title: "TIFF",
    resourceType: "images",
    path: "/sample-images/tiff",
  },
  {
    key: "heic",
    title: "HEIC",
    resourceType: "images",
    path: "/sample-images/heic",
  },
  {
    key: "ico",
    title: "ICO",
    resourceType: "images",
    path: "/sample-images/ico",
  },
  {
    key: "avif",
    title: "AVIF",
    resourceType: "images",
    path: "/sample-images/avif",
  },
  {
    key: "dng",
    title: "DNG",
    resourceType: "images",
    path: "/sample-images/dng",
  },
  {
    key: "tga",
    title: "TGA",
    resourceType: "images",
    path: "/sample-images/tga",
  },
];

export const videoTabData = [
  {
    key: "3gp",
    title: "3GP",
    resourceType: "videos",
    path: "/sample-videos/3gp",
  },
  {
    key: "mp4",
    title: "MP4",
    resourceType: "videos",
    path: "/sample-videos/mp4",
  },
  {
    key: "mov",
    title: "MOV",
    resourceType: "videos",
    path: "/sample-videos/mov",
  },
  {
    key: "avi",
    title: "AVI",
    resourceType: "videos",
    path: "/sample-videos/avi",
  },
  {
    key: "flv",
    title: "FLV",
    resourceType: "videos",
    path: "/sample-videos/flv",
  },
  {
    key: "webm",
    title: "WEBM",
    resourceType: "videos",
    path: "/sample-videos/webm",
  },
  {
    key: "mkv",
    title: "MKV",
    resourceType: "videos",
    path: "/sample-videos/mkv",
  },
];

export const documentTabData = [
  {
    key: "pdf",
    title: "PDF",
    resourceType: "documents",
    path: "/sample-documents/pdf",
  },
  {
    key: "doc",
    title: "DOC",
    resourceType: "documents",
    path: "/sample-documents/doc",
  },
  {
    key: "docx",
    title: "DOCX",
    resourceType: "documents",
    path: "/sample-documents/docx",
  },
  {
    key: "xls",
    title: "XLS",
    resourceType: "documents",
    path: "/sample-documents/xls",
  },
  {
    key: "xlsx",
    title: "XLSX",
    resourceType: "documents",
    path: "/sample-documents/xlsx",
  },
  {
    key: "odt",
    title: "ODT",
    resourceType: "documents",
    path: "/sample-documents/odt",
  },
  {
    key: "rtf",
    title: "RTF",
    resourceType: "documents",
    path: "/sample-documents/rtf",
  },
  {
    key: "ppt",
    title: "PPT",
    resourceType: "documents",
    path: "/sample-documents/ppt",
  },
  {
    key: "pptx",
    title: "PPTX",
    resourceType: "documents",
    path: "/sample-documents/pptx",
  },
  {
    key: "txt",
    title: "TXT",
    resourceType: "documents",
    path: "/sample-documents/txt",
  },
  {
    key: "csv",
    title: "CSV",
    resourceType: "documents",
    path: "/sample-documents/csv",
  },
];

export const audioTabData = [
  {
    key: "mp3",
    title: "MP3",
    resourceType: "audios",
    path: "/sample-audios/mp3",
  },
  {
    key: "aac",
    title: "AAC",
    resourceType: "audios",
    path: "/sample-audios/aac",
  },
  {
    key: "wav",
    title: "WAV",
    resourceType: "audios",
    path: "/sample-audios/wav",
  },
  {
    key: "ogg",
    title: "OGG",
    resourceType: "audios",
    path: "/sample-audios/ogg",
  },
  {
    key: "aiff",
    title: "AIFF",
    resourceType: "audios",
    path: "/sample-audios/aiff",
  },
  {
    key: "flac",
    title: "FLAC",
    resourceType: "audios",
    path: "/sample-audios/flac",
  },
];

export const archiveTabData = [
  {
    key: "zip",
    title: "ZIP",
    resourceType: "archives",
    path: "/sample-archives/zip",
  },
  {
    key: "rar",
    title: "RAR",
    resourceType: "archives",
    path: "/sample-archives/rar",
  },
  {
    key: "7z",
    title: "7Z",
    resourceType: "archives",
    path: "/sample-archives/7z",
  },
  {
    key: "tar",
    title: "TAR",
    resourceType: "archives",
    path: "/sample-archives/tar",
  },
];
export const about = [
  {
    key: "about-us",
    title: "About Us",
    resourceType: "About Us",
    path: "about-us",
  },
  {
    key: "privacy-policy",
    title: "Privacy Policy",
    resourceType: "Privacy Policy",
    path: "privacy-policy",
  },
  {
    key: "terms-of-service",
    title: "Terms of Service",
    resourceType: "terms-of-service",
    path: "terms-of-service",
  },
  {
    key: "contact-us",
    title: "Contact Us",
    resourceType: "Contact Us",
    path: "contact-us",
  },
];

export const codeTabData = [
  { key: "xml", title: "XML", resourceType: "code", path: "/sample-code/xml" },
  {
    key: "json",
    title: "JSON",
    resourceType: "code",
    path: "/sample-code/json",
  },
  { key: "php", title: "PHP", resourceType: "code", path: "/sample-code/php" },
  {
    key: "js",
    title: "JAVASCRIPT",
    resourceType: "code",
    path: "/sample-code/js",
  },
  {
    key: "java",
    title: "JAVA",
    resourceType: "code",
    path: "/sample-code/java",
  },
  { key: "bat", title: "BAT", resourceType: "code", path: "/sample-code/bat" },
  { key: "rb", title: "RUBY", resourceType: "code", path: "/sample-code/rb" },
  { key: "c", title: "C", resourceType: "code", path: "/sample-code/c" },
  { key: "cpp", title: "C++", resourceType: "code", path: "/sample-code/cpp" },
  {
    key: "html",
    title: "HTML",
    resourceType: "code",
    path: "/sample-code/html",
  },
  {
    key: "yaml",
    title: "YAML",
    resourceType: "code",
    path: "/sample-code/yaml",
  },
  { key: "py", title: "PYTHON", resourceType: "code", path: "/sample-code/py" },
];

export const allFileType = [
  ...imageTabData,
  ...videoTabData,
  ...audioTabData,
  ...documentTabData,
  ...archiveTabData,
  ...codeTabData,
];

// Use to navigate on the particular path as per the file type
export const fileTypeToBasePath = {
  // Images
  jpg: "/sample-images/sample-jpg",
  png: "/sample-images/sample-png",
  webp: "/sample-images/sample-webp",
  svg: "/sample-images/sample-svg",
  gif: "/sample-images/sample-gif",
  bmp: "/sample-images/sample-bmp",
  psd: "/sample-images/sample-psd",
  tiff: "/sample-images/sample-tiff",
  ico: "/sample-images/sample-ico",
  heic: "/sample-images/sample-heic",
  avif: "/sample-images/sample-avif",
  dng: "/sample-images/sample-dng",
  tga: "/sample-images/sample-tga",

  // Video
  mp4: "/sample-videos/sample-mp4",
  avi: "/sample-videos/sample-avi",
  flv: "/sample-videos/sample-flv",
  mov: "/sample-videos/sample-mov",
  mkv: "/sample-videos/sample-mkv",
  webm: "/sample-videos/sample-webm",
  "3gp": "/sample-videos/sample-3gp",

  // Audio
  mp3: "/sample-audios/sample-mp3",
  wav: "/sample-audios/sample-wav",
  aac: "/sample-audios/sample-aac",
  ogg: "/sample-audios/sample-ogg",
  aiff: "/sample-audios/sample-aiff",
  flac: "/sample-audios/sample-flac",

  // Documents
  pdf: "/sample-documents/sample-pdf",
  doc: "/sample-documents/sample-doc",
  docx: "/sample-documents/sample-docx",
  xls: "/sample-documents/sample-xls",
  xlsx: "/sample-documents/sample-xlsx",
  odt: "/sample-documents/sample-odt",
  rtf: "/sample-documents/sample-rtf",
  ppt: "/sample-documents/sample-ppt",
  pptx: "/sample-documents/sample-pptx",
  txt: "/sample-documents/sample-txt",
  csv: "/sample-documents/sample-csv",

  // Archives
  zip: "/sample-archives/sample-zip",
  rar: "/sample-archives/sample-rar",
  "7z": "/sample-archives/sample-7z",
  tar: "/sample-archives/sample-tar",

  //code
  xml: "/sample-code/sample-xml",
  json: "/sample-code/sample-json",
  java: "/sample-code/sample-java",
  php: "/sample-code/sample-php",
  js: "/sample-code/sample-javascript",
  bat: "/sample-code/sample-bat",
  rb: "/sample-code/sample-ruby",
  c: "/sample-code/sample-c",
  cpp: "/sample-code/sample-cpp",
  py: "/sample-code/sample-python",
  html: "/sample-code/sample-html",
  yaml: "/sample-code/sample-yaml",
};

export const categories = [
  {
    key: "images",
    icon: ImageIcon,
    title: "Images",
    description:
      "Download high-quality sample images in 13+ formats, including JPG, PNG, WEBP, SVG, GIF, BMP, PSD, TIFF, HEIC, ICO, AVIF, DNG, and TGA. Instantly access diverse resolutions and sizes for testing UI layouts, validating uploads, or experimenting with compression. No registration required — perfect for developers, designers, and QA testers",
    downloads: "",
    color: "text-white",
    bgDownload: "bg-primary-subtle",
    textDownload: "text-primary-emphasis",
  },
  {
    key: "videos",
    icon: Video,
    title: "Videos",
    description:
      "Get free sample videos in 6+ popular formats like MP4, AVI, MKV, MOV, WebM, FLV, and 3GP. Available in multiple resolutions and frame rates, these files are ideal for testing playback, streaming performance, compression, or editing workflows. Instantly download and use in your projects.",
    downloads: "-",
    color: "text-white",
    bgDownload: "bg-info-subtle",
    textDownload: "text-info-emphasis",
  },
  {
    key: "audios",
    icon: Music,
    title: "Audio",
    description:
      "Access 50+ sample audio files, including MP3, WAV, AAC, OGG, AIFF, FLAC, and M4A. Explore royalty-free music, sound effects, and clips to test playback, compression, or audio editing. Perfect for developers, sound engineers, and content creators.",
    downloads: "-",
    color: "text-white",
    bgDownload: "bg-success-subtle",
    textDownload: "text-success-emphasis",
  },
  {
    key: "documents",
    icon: FileText,
    title: "Documents",
    description:
      "Download sample files in PDF, DOC, DOCX, PPT, PPTX, XLS, XLSX, TXT, ODT, RTF, and CSV formats. Test file uploads, formatting, parsing, and compatibility with various applications. Ideal for students, professionals, and developers working with reports, contracts, presentations, and more.",
    downloads: "-",
    color: "text-white",
    bgDownload: "bg-danger-subtle",
    textDownload: "text-danger-emphasis",
  },
  {
    key: "archives",
    icon: Archive,
    title: "Archives",
    description:
      "Access free test archives in ZIP, RAR, 7Z, and TAR formats. Explore different compression levels, file structures, and security settings to validate extraction algorithms, uploads, or system compatibility. Perfect for developers, QA engineers, and IT professionals",
    downloads: "-",
    color: "text-white",
    bgDownload: "bg-warning-subtle",
    textDownload: "text-warning-emphasis",
  },
  {
    key: "code",
    icon: MoreHorizontal,
    title: "Code",
    description:
      "Get sample files in HTML, PHP, JSON, JavaScript, Python, Java, XML, YAML, and C++. Test code editors, syntax highlighting, API responses, and security tools using professionally created test cases. Suitable for developers, students, and QA engineers.",
    downloads: "-",
    color: "text-white",
    bgDownload: "bg-primary-subtle",
    textDownload: "text-primary-emphasis",
  },
];

export const faqs = [
  {
    question: "Are all files really free?",
    answer:
      "Yes! All sample files on SampleFiles.dev are completely free to download and use. No hidden fees, no registration required.",
  },
  {
    question: "Can I request specific file formats?",
    answer:
      'Use the "Request File" button to submit requests for specific file types or formats you need for your projects.',
  },
  {
    question: "Do I need to create an account or sign up?",
    answer:
      "No account or signup is required. Simply browse the categories and download the files you need instantly.",
  },
  {
    question: "Is there a limit on how many files I can download?",
    answer: "No limits! Download as many files as you need, whenever you want.",
  },
  {
    question: "How often are new files added?",
    answer:
      "We regularly update our library with new images, videos, audios, and documents to keep our collection fresh and useful.",
  },
];

export const getMetaData = (fileType) => {
  switch (fileType) {
    // ----------------- Images -----------------
    case "home":
      return {
        title: "Download Free Sample Files – Images, Videos, PDFs & More",
        screenTitle: "",
        description:
          "Download free sample images, videos, PDFs, and documents for testing, demos, and learning. Perfect for developers, students, and designers to explore safely.",
        keywords: "sample jpg, file",
        bodyText: ``,
      };

    case "jpg":
      return {
        title: "Sample JPG image download - Free Sample Files",
        screenTitle: "Sample jpg download",
        description:
          "Download a sample JPG image file for testing and development. High-quality JPEG format image available for free.",
        keywords:
          "sample jpg, jpg image download, jpeg file example, free jpg file",
        bodyText: (
          <article>
            <p>
              A <strong>JPG</strong> (or <strong>JPEG</strong>) file is one of
              the most popular and widely supported
              <strong> image formats</strong> used today. It stands for
              <strong> Joint Photographic Experts Group</strong>, the committee
              that created this format in the late 1980s. The primary goal of
              JPEG was to provide a standard for compressing photographic images
              without making them appear blurry or pixelated. Thanks to its{" "}
              <strong> lossy compression algorithm</strong>, a JPG file can
              significantly reduce file size while retaining high visual
              quality—making it an ideal choice for
              <strong> digital photography</strong>,
              <strong> web graphics</strong>, and
              <strong> social media sharing</strong>.
            </p>

            <p>
              One of the biggest advantages of the
              <strong> JPEG format</strong> is its universal compatibility.
              Every modern device—be it a smartphone, tablet, digital camera, or
              web browser—supports JPG files. This ensures that your images can
              be viewed, shared, and uploaded easily across platforms. In
              addition, the smaller file size makes it perfect for
              <strong> website optimization</strong>, improving
              <strong> page loading speed</strong> and overall
              <strong> SEO performance</strong>. Websites that use optimized JPG
              images tend to load faster, which helps increase
              <strong> Google search rankings</strong> and enhances user
              experience.
            </p>

            <p>
              From professional photographers to web developers, everyone relies
              on JPG for its excellent balance between
              <strong> image quality</strong> and
              <strong> compression efficiency</strong>. You can adjust the
              compression level while saving an image to control file size and
              clarity—offering flexibility for both print and digital use.
              Unlike formats such as
              <strong> PNG</strong> (which is best for graphics and
              transparency) or
              <strong> WEBP</strong> (which may not be supported everywhere),
              JPEG remains a timeless standard that ensures reliability and
              accessibility across all devices.
            </p>

            <p>
              <strong>Advantages of JPG:</strong>
              <ul>
                <li>High compression ratio with minimal visual loss</li>
                <li>Compatible with all devices and browsers</li>
                <li>Ideal for photos, artwork, and online sharing</li>
                <li>Smaller file size improves website performance</li>
                <li>Easy to edit and convert to other image formats</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> When saving images for your website, use
              a compression level between <strong>70–85%</strong> to maintain
              excellent quality while keeping file sizes small. Tools like
              <strong> TinyJPG</strong> or <strong>ImageOptim</strong> can help
              you compress images efficiently without noticeable loss in detail.
              Always include descriptive <strong>alt text</strong> and
              <strong> file names</strong> (e.g., “sunset-beach-photo.jpg”) to
              boost your
              <strong>image SEO</strong> and make your content more discoverable
              in
              <strong> Google Image Search</strong>.
            </p>
          </article>
        ),
      };
    case "png":
      return {
        title: "Sample png image download - Free Sample Files",
        screenTitle: "Sample png download",
        description:
          "Download a sample PNG image file for testing projects, design, and software. Free PNG sample available instantly.",
        keywords:
          "sample png, png image download, transparent png, free png file",
        bodyText: (
          <article>
            <p>
              A <strong>PNG</strong> (<strong>Portable Network Graphics</strong>
              ) file is a popular
              <strong> lossless image format</strong> known for its ability to
              preserve image quality while supporting
              <strong> transparency</strong> and detailed color information.
              Introduced in the mid-1990s as an improved alternative to the
              older <strong>GIF format</strong>, PNG quickly became a favorite
              among <strong>designers</strong> and
              <strong> web developers</strong>
              for its clean rendering and crisp edges—especially in graphics,
              logos, and icons.
            </p>

            <p>
              Unlike JPEG, which uses <strong>lossy compression</strong>, PNG
              maintains every pixel’s detail, making it perfect for
              <strong> high-quality images</strong>,<strong>screenshots</strong>
              , and
              <strong> digital artwork</strong> where clarity is essential. PNG
              also supports <strong>alpha transparency</strong>, allowing smooth
              blending with backgrounds—ideal for
              <strong> UI elements</strong>,<strong>overlays</strong>, and
              <strong> responsive design</strong>.
            </p>

            <p>
              Another strength of the <strong>PNG format</strong> is its
              <strong> color depth</strong>. With support for up to 48-bit color
              and 16-bit grayscale images, PNG files offer exceptional detail
              and accuracy. While they can be larger in size than JPEGs, their
              superior image fidelity makes them essential for design and
              printing tasks that demand precision.
            </p>

            <p>
              <strong>Advantages of PNG:</strong>
              <ul>
                <li>Lossless compression retains perfect image quality</li>
                <li>Supports transparency and alpha channels</li>
                <li>Ideal for logos, icons, and digital design assets</li>
                <li>Excellent color depth and gradient rendering</li>
                <li>Universally supported across browsers and platforms</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Use PNG for images that need transparent
              backgrounds or fine details, but consider compressing large files
              with tools like <strong>TinyPNG </strong>
              or <strong> PNGGauntlet</strong> to improve
              <strong> website loading speed</strong> and
              <strong> SEO performance</strong>. For photos, use JPEG or WEBP
              instead to save bandwidth.
            </p>
          </article>
        ),
      };
    case "webp":
      return {
        title: "Sample WEBP image download - Free Sample Files",
        screenTitle: "Sample webp download",
        description:
          "Get a sample WEBP image file for testing and optimization. Free WEBP format download provided.",
        keywords:
          "sample webp, webp image download, webp example file, free webp",
        bodyText: (
          <article>
            <p>
              <strong>WEBP</strong> is a modern <strong>image format </strong>
              developed by
              <strong> Google</strong> to provide
              <strong> superior compression</strong> and
              <strong> faster web performance</strong>. It combines the best
              features of both <strong>JPEG</strong> and <strong>PNG</strong>,
              offering
              <strong> lossy</strong> and <strong>lossless compression </strong>
              along with support for <strong>transparency</strong> and
              <strong> animation</strong>. Designed specifically for the
              <strong> web</strong>, WEBP images can be up to 30–40% smaller in
              size than equivalent JPEG or PNG files without sacrificing visible
              quality.
            </p>

            <p>
              The biggest advantage of WEBP lies in its efficiency. Smaller
              image sizes mean faster <strong>page loading times</strong>,
              improved
              <strong> Core Web Vitals</strong>, and better overall
              <strong> SEO performance</strong>. Many major platforms, including
              <strong> WordPress</strong>, <strong>Shopify</strong>, and
              <strong> Chrome</strong>, now natively support WEBP to enhance
              user experience and reduce bandwidth consumption.
            </p>

            <p>
              While compatibility used to be an issue, most modern browsers and
              operating systems now support WEBP, making it a reliable choice
              for
              <strong> developers</strong> and
              <strong> content creators</strong> who want smaller yet
              high-quality visuals for the web.
            </p>

            <p>
              <strong>Advantages of WEBP:</strong>
              <ul>
                <li>Smaller file size with high visual quality</li>
                <li>Supports transparency (like PNG)</li>
                <li>Can store animations (like GIF)</li>
                <li>Faster loading times improve SEO</li>
                <li>Ideal for modern web optimization</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Convert existing images to WEBP using
              tools like
              <strong> Squoosh</strong> or <strong>TinyPNG</strong> to cut file
              sizes and speed up your site. Always keep fallback JPEG or PNG
              versions for older browsers that may not support WEBP.
            </p>
          </article>
        ),
      };
    case "svg":
      return {
        title: "Sample SVG image download - Free Sample Files",
        screenTitle: "Sample SVG download",
        description:
          "Download a sample SVG vector image file for testing in web and design projects. Scalable vector graphic format.",
        keywords: "sample svg, svg download, vector svg file, free svg example",
        bodyText: (
          <article>
            <p>
              The <strong>SVG</strong> (
              <strong>Scalable Vector Graphics</strong>) format is a
              <strong> vector-based image format</strong> that uses mathematical
              formulas instead of pixels to represent shapes and lines. Unlike
              raster formats such as JPEG or PNG, SVG files can scale infinitely
              without losing quality—making them ideal for
              <strong> logos</strong>,<strong> icons</strong>,
              <strong> infographics</strong>, and
              <strong>web illustrations</strong>.
            </p>

            <p>
              One of SVG’s greatest strengths is its
              <strong> scalability</strong>. Whether you’re viewing an image on
              a tiny smartphone screen or a large 4K monitor, an SVG remains
              perfectly crisp. Additionally, because SVG files are written in
              XML, they can be easily edited using text editors or animated with
              <strong> CSS</strong> and <strong>JavaScript</strong>.
            </p>

            <p>
              SVGs also have a very small file size for simple graphics,
              improving
              <strong> website speed</strong> and <strong>SEO rankings</strong>.
              Many modern websites use SVGs for logos and UI icons to achieve
              sharp visuals with minimal performance impact.
            </p>

            <p>
              <strong>Advantages of SVG:</strong>
              <ul>
                <li>Scales to any resolution without quality loss</li>
                <li>Lightweight and SEO-friendly</li>
                <li>Supports animation and interactivity</li>
                <li>Editable via code or design tools</li>
                <li>Perfect for logos, charts, and icons</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Use SVG for simple graphics and icons
              instead of PNG to save bandwidth. Minify SVG files and remove
              unnecessary metadata using tools like <strong>SVGO</strong> to
              further boost performance.
            </p>
          </article>
        ),
      };
    case "gif":
      return {
        title: "Sample GIF image - Download .gif Sample Files",
        screenTitle: "Sample GIF download",
        description:
          "Free sample GIF image file for testing animations and image rendering. Download instantly.",
        keywords:
          "sample gif, gif animation, gif download free, gif file example",
        bodyText: (
          <article>
            <p>
              A <strong>GIF</strong> (
              <strong>Graphics Interchange Format</strong>) is a classic
              <strong> image format</strong> best known for supporting
              <strong> short animations</strong> and
              <strong> looping graphics</strong>. It uses
              <strong> lossless compression</strong> and a limited
              <strong> 256-color palette</strong>, making it ideal for
              <strong> simple graphics</strong>, <strong>logos</strong>, and
              <strong> fun memes</strong> that don’t require high-resolution
              color detail.
            </p>

            <p>
              Despite its age (introduced by CompuServe in 1987), GIF remains
              one of the most widely used formats on the internet. It’s the
              go-to choice for
              <strong> social media reactions</strong>,
              <strong> animated icons</strong>, and
              <strong> messaging apps</strong>. However, for large animations or
              full-motion video, formats like <strong>WEBP</strong> or
              <strong> MP4</strong> are more efficient.
            </p>

            <p>
              <strong>Advantages of GIF:</strong>
              <ul>
                <li>Supports animation and looping</li>
                <li>Small file size for simple graphics</li>
                <li>Broad browser and platform support</li>
                <li>Lossless compression for static images</li>
                <li>Ideal for memes and reaction clips</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Keep GIF durations short (under 5
              seconds) to reduce file size. Convert large GIFs to
              <strong> MP4</strong> or
              <strong> WEBP</strong> using tools like <strong>EZGIF</strong> to
              optimize load times and improve
              <strong> page performance</strong>.
            </p>
          </article>
        ),
      };
    case "bmp":
      return {
        title: "Sample BMP image Download - Free Sample Files",
        screenTitle: "Sample BMP download",
        description:
          "Download a sample BMP image file for testing legacy formats and applications. Free BMP sample.",
        keywords:
          "sample bmp, bmp file download, bitmap image example, bmp test file",
        bodyText: (
          <article>
            <p>
              The <strong>BMP</strong> (<strong>Bitmap</strong>) format is one
              of the earliest <strong>raster image formats</strong> developed by
              Microsoft for Windows systems. It stores images as uncompressed
              pixel data, which means every pixel’s color information is saved
              individually. This results in large file sizes but guarantees{" "}
              <strong>excellent image quality</strong>
              with no compression artifacts.
            </p>

            <p>
              <strong>BMP files</strong> are often used in
              <strong> software development</strong>,
              <strong> digital imaging</strong>, and
              <strong> scientific applications</strong>
              where raw pixel accuracy is important. Because BMP uses a simple
              structure, it’s easy for programs to read and write, making it
              ideal for
              <strong> testing image processing tools</strong> or
              <strong> developing graphics software</strong>.
            </p>

            <p>
              While the format has largely been replaced by modern alternatives
              like
              <strong> PNG</strong> and <strong>JPEG</strong> for everyday use,
              BMP still serves as a dependable standard for internal system
              graphics, icons, and screenshots in legacy Windows applications.
            </p>

            <p>
              <strong>Advantages of BMP:</strong>
              <ul>
                <li>Uncompressed and lossless — retains exact pixel data</li>
                <li>Extremely simple and widely supported format</li>
                <li>Perfect for testing, editing, and raw data manipulation</li>
                <li>No quality degradation over multiple saves</li>
                <li>Ideal for archival or system-level images</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Use BMP for raw or test images when you
              need exact color data. For web use, convert BMP to PNG or WEBP to
              reduce file size and improve <strong>page speed </strong>
              and <strong>SEO ranking</strong>.
            </p>
          </article>
        ),
      };
    case "psd":
      return {
        title: "Sample PSD file Download - Free Photoshop Sample Files",
        screenTitle: "Sample PSD download",
        description:
          "Download a sample PSD file for Adobe Photoshop testing, design projects, and image editing. Free PSD sample.",
        keywords:
          "sample psd, psd file download, photoshop file example, layered psd sample, psd test file",
        bodyText: (
          <article>
            <p>
              A <strong>PSD</strong> (<strong>Photoshop Document</strong>) file
              is the native format used by
              <strong> Adobe Photoshop</strong> to store
              <strong> layered images</strong>. Unlike flat image formats such
              as JPEG or PNG, PSD files preserve layers, masks, adjustment
              settings, and transparency, allowing designers to return and edit
              every element of their project non-destructively.
            </p>

            <p>
              This makes PSD the go-to format for
              <strong> graphic designers</strong>,
              <strong> photographers</strong>, and
              <strong> digital artists</strong> who need flexibility during the
              design process. PSD supports both
              <strong> RGB</strong> and <strong> CMYK color models</strong>,
              making it suitable for both web and print workflows.
            </p>

            <p>
              PSD files can be quite large due to their layered nature, but they
              are essential for collaborative projects where image components
              need to be individually edited. Most modern design tools,
              including
              <strong> GIMP</strong>, <strong> Affinity Photo</strong>, and
              <strong> Photopea</strong>, can open and edit PSD files, ensuring
              compatibility beyond Adobe software.
            </p>

            <p>
              <strong>Advantages of PSD:</strong>
              <ul>
                <li>Preserves layers, masks, and adjustment settings</li>
                <li>High-quality, editable format for design projects</li>
                <li>Supports both RGB and CMYK color spaces</li>
                <li>Compatible with various professional tools</li>
                <li>Ideal for print, web, and photo editing</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Always export PSD designs to compressed
              formats (like PNG, JPEG, or WEBP) before uploading to the web to
              reduce load times. Keep the original PSD as a master copy for
              future edits.
            </p>

            <p>
              Download <strong>free PSD sample files</strong> from our site to
              test Photoshop features, try new templates, or experiment with
              design concepts. Perfect for anyone learning or working in
              <strong> graphic design and digital illustration</strong>.
            </p>
          </article>
        ),
      };
    case "tiff":
      return {
        title: "Sample TIFF image download - Free TIFF Sample Files",
        screenTitle: "Sample tiff download",
        description:
          "Download a sample TIFF image file for high-quality print and archival purposes. Free TIFF sample.",
        keywords:
          "sample tiff, tiff file download, tiff image example, high-quality image format, tiff test file",
        bodyText: (
          <article>
            <article>
              <p>
                The <strong>TIFF</strong> (
                <strong>Tagged Image File Format</strong>) is a
                professional-grade <strong>lossless image format</strong> widely
                used in
                <strong> photography</strong>, <strong>printing</strong>, and
                <strong> scanning</strong>. It was developed by Aldus (now
                Adobe) and offers incredible flexibility, supporting multiple
                layers, color depths, and compression options.
              </p>

              <p>
                Unlike compressed formats like JPEG, TIFF files maintain exact
                image quality with no loss of data—making them perfect for
                <strong> photo editing</strong>,
                <strong> archival storage</strong>, and
                <strong> medical imaging</strong>. They also support
                <strong> metadata</strong> and <strong>multiple images</strong>
                in a single file, which is valuable in document management and
                publishing.
              </p>

              <p>
                Though TIFF files are large, their precision makes them
                indispensable for professionals who require the highest
                fidelity, especially before printing or publication.
              </p>

              <p>
                <strong>Advantages of TIFF:</strong>
                <ul>
                  <li>Lossless quality with detailed color accuracy</li>
                  <li>Supports multiple pages and layers</li>
                  <li>Excellent for scanning and archiving</li>
                  <li>Ideal for printing and publishing workflows</li>
                  <li>Broad compatibility across professional software</li>
                </ul>
              </p>

              <p>
                <strong>Pro Tip:</strong> Use TIFF for your master image files,
                then export compressed versions (JPEG or WEBP) for web use. This
                preserves original quality while optimizing performance.
              </p>

              <p>
                You can <strong>download free TIFF sample files</strong> from
                our site for software testing, quality checks, and professional
                use. This format is essential for those working with
                <strong> high-quality digital imaging</strong>.
              </p>
            </article>
          </article>
        ),
      };
    case "heic":
      return {
        title: "Sample HEIC image download - Free HEIC Sample Files",
        screenTitle: "Sample heic download",
        description:
          "Download a sample HEIC image file for testing modern formats and iOS compatibility. Free HEIC sample.",
        keywords:
          "sample heic, heic file download, high efficiency image format, apple heic sample file",
        bodyText: (
          <article>
            <p>
              <strong>HEIC (High Efficiency Image Coding)</strong> is a modern
              <strong> image format</strong> designed to store high-quality
              images in smaller file sizes. Introduced by
              <strong> Apple in iOS 11</strong> and based on the HEIF standard,
              <strong> HEIC files</strong> offer advanced compression
              techniques, allowing images to maintain exceptional detail while
              using significantly less storage space compared to JPEG or PNG.
            </p>
            <p>
              HEIC files are widely used on
              <strong> iPhones, iPads, and macOS</strong> devices, making them
              ideal for
              <strong>
                {" "}
                mobile photography, digital albums, and high-resolution image
                sharing
              </strong>
              . With support for features like
              <strong>
                {" "}
                16-bit color depth, transparency, and live photos
              </strong>
              , HEIC is a powerful choice for modern image workflows.
            </p>

            <article>
              <p>
                HEIC supports multiple images, transparency, 16-bit color depth,
                and even animations, which makes it a powerful alternative to
                older formats. Its superior compression algorithm ensures
                sharper details and richer color, even in smaller file sizes.
              </p>

              <p>
                The only downside is limited compatibility with older software
                and systems, but support is rapidly growing across platforms,
                including Windows 11, macOS, and major web browsers.
              </p>

              <p>
                <strong>Advantages of HEIC:</strong>
                <ul>
                  <li>Half the size of JPEG with better quality</li>
                  <li>Supports transparency and image sequences</li>
                  <li>
                    Stores multiple photos in one file (e.g., bursts or Live
                    Photos)
                  </li>
                  <li>Efficient use of storage space</li>
                  <li>Modern and future-proof format</li>
                </ul>
              </p>

              <p>
                <strong>Pro Tip:</strong> Convert HEIC to JPEG or WEBP when
                sharing online to ensure broad compatibility. Tools like
                <strong> iMazing</strong> or
                <strong> CloudConvert</strong> make the process seamless.
              </p>

              <p>
                Download <strong>free HEIC sample files</strong> from our
                website to test compatibility, software performance, and file
                conversions. This format is perfect for developers, designers,
                and photographers working with
                <strong> next-generation image standards</strong>.
              </p>
            </article>
          </article>
        ),
      };
    case "ico":
      return {
        title: "Sample ICO icon download - Free Icon Sample Files",
        screenTitle: "Sample ICO download",
        description:
          "Download a sample ICO file for app and web icon testing. Free ICO sample.",
        keywords:
          "sample ico, ico file download, icon file example, windows icon sample, favicon test file",
        bodyText: (
          <article>
            <p>
              The <strong>ICO</strong> file format is used primarily for
              <strong> computer icons</strong> in Windows applications and
              websites. An ICO file can contain multiple sizes and color depths
              of the same image, allowing the system to display the most
              appropriate version depending on context—like taskbars, menus, or
              desktop icons.
            </p>

            <p>
              ICO files typically store <strong>PNG</strong> or
              <strong> BMP</strong>-based images in square dimensions (16×16,
              32×32, 64×64, etc.), offering flexibility across different screen
              resolutions. This makes them essential for
              <strong> favicon design</strong> and
              <strong> desktop applications</strong>.
            </p>

            <p>
              Though not designed for photography or general graphics, the ICO
              format remains a vital part of UI/UX design for representing
              applications, shortcuts, and websites.
            </p>

            <p>
              <strong>Advantages of ICO:</strong>
              <ul>
                <li>Stores multiple icon sizes and resolutions</li>
                <li>Native support in Windows OS</li>
                <li>Perfect for favicons and desktop apps</li>
                <li>Compact and easy to load</li>
                <li>Supports transparency and color depth</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Use tools like
              <strong> RealFaviconGenerator </strong>
              or <strong> ConvertICO</strong> to create high-quality ICO files
              from PNGs. Always include multiple sizes to ensure proper display
              across all devices.
            </p>

            <p>
              Download <strong>free ICO sample files</strong> from our website
              to test web design, software development, or icon rendering in
              different environments. Ideal for
              <strong>
                {" "}
                developers, designers, and branding professionals
              </strong>
              .
            </p>
          </article>
        ),
      };
    case "avif":
      return {
        title: "Sample AVIF image file download - Free Image Sample Files",
        screenTitle: "Sample AVIF download",
        description:
          "Download a sample AVIF file for testing next-gen image compression. Free AVIF sample.",
        keywords:
          "sample avif, avif file download, avif image example, modern image format, high efficiency image",
        bodyText: (
          <article>
            <p>
              The <strong>AVIF</strong> (<strong>AV1 Image File Format</strong>)
              is a cutting-edge image format developed by the Alliance for Open
              Media. It uses the same technology as the{" "}
              <strong>AV1 video codec</strong>, delivering exceptional{" "}
              <strong>compression efficiency</strong> and
              <strong> image quality</strong> that surpasses both
              <strong> WEBP</strong> and
              <strong>JPEG</strong>.
            </p>

            <p>
              AVIF supports <strong>HDR imaging</strong>,
              <strong> transparency</strong>,<strong>animation</strong>, and
              <strong> 10–12-bit color depth</strong> while keeping file sizes
              extremely small. This makes it ideal for
              <strong> modern websites</strong> and
              <strong> streaming platforms </strong>
              that demand high-quality visuals with minimal bandwidth.
            </p>

            <p>
              Though browser and OS support are still expanding, AVIF is rapidly
              becoming the preferred choice for next-generation web performance
              and
              <strong> SEO optimization</strong>.
            </p>

            <p>
              <strong>Advantages of AVIF:</strong>
              <ul>
                <li>Superior compression compared to JPEG and WEBP</li>
                <li>Supports HDR, transparency, and animations</li>
                <li>Excellent color accuracy with deep bit depth</li>
                <li>Significantly reduces bandwidth usage</li>
                <li>Perfect for high-performance web applications</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Use AVIF for product images, hero
              banners, and background visuals where performance matters. Always
              offer fallback formats for unsupported browsers.
            </p>

            <p>
              Download <strong>free AVIF sample files</strong> from our website
              to test compatibility, evaluate quality, and integrate into your
              development or design workflow. Essential for
              <strong>
                {" "}
                web developers, photographers, and content creators
              </strong>
              .
            </p>
          </article>
        ),
      };
    case "dng":
      return {
        title: "Sample DNG file download - Free Raw Photo Sample Files",
        screenTitle: "Sample DNG download",
        description:
          "Download a sample DNG file for testing raw photo editing. Free DNG sample.",
        keywords:
          "sample dng, dng file download, digital negative example, raw photo sample, camera raw file",
        bodyText: (
          <article>
            <p>
              <strong>DNG</strong> (<strong>Digital Negative</strong>) is an
              open-source
              <strong> RAW image format</strong> developed by Adobe for
              photographers. It stores unprocessed image data directly from a
              camera’s sensor, allowing complete control over exposure, white
              balance, and color grading during post-production.
            </p>

            <p>
              Unlike proprietary RAW formats (like CR2 or NEF), DNG is
              standardized and ensures long-term compatibility across software
              and platforms. It’s ideal for professional photographers who value
              both image quality and archival stability.
            </p>

            <p>
              <strong>DNG files</strong> retain all sensor information,
              providing flexibility to make detailed edits without losing
              quality. Although they are larger in size than JPEGs, the editing
              potential makes them indispensable for serious image
              professionals.
            </p>

            <p>
              <strong>Advantages of DNG:</strong>
              <ul>
                <li>Open standard RAW format (no vendor lock-in)</li>
                <li>Preserves full image detail and dynamic range</li>
                <li>Perfect for professional photo editing</li>
                <li>Ensures long-term file compatibility</li>
                <li>Supports embedded metadata and previews</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Always archive your RAW images in DNG
              format to future-proof your work. For sharing or publishing,
              export them as TIFF or JPEG.
            </p>

            <p>
              Download <strong>free DNG sample files</strong> from our website
              to test raw processing software, practice photo editing
              techniques, or verify software compatibility. A vital resource for
              <strong>
                {" "}
                photographers, photo editors, and software testers
              </strong>
              .
            </p>
          </article>
        ),
      };
    case "tga":
      return {
        title: "Sample TGA file download - Free Raster Graphic Sample Files",
        screenTitle: "Sample TGA download",
        description:
          "Download a sample TGA file for testing images with transparency. Free TGA sample.",
        keywords:
          "sample tga, tga file download, targa image example, truevision tga, image with alpha channel",
        bodyText: (
          <article>
            <p>
              The <strong>TGA</strong> (<strong>Truevision TARGA</strong>)
              format was developed by Truevision Inc. in the 1980s for use with
              high-end video and animation hardware. It’s a
              <strong> raster image format</strong> that supports
              <strong> up to 32-bit color depth</strong> and
              <strong> alpha transparency</strong>, making it popular in
              <strong> game development</strong> and
              <strong> 3D rendering</strong>.
            </p>

            <p>
              TGA files are often used for textures, sprites, and graphical
              elements in video games because they store pixel data accurately
              and are supported by most 3D engines like <strong>Unity </strong>
              and <strong>Unreal Engine</strong>. Though it’s less common for
              web use, TGA remains valuable in digital content creation
              pipelines.
            </p>

            <p>
              <strong>Advantages of TGA:</strong>
              <ul>
                <li>
                  Supports alpha transparency and color depth up to 32-bit
                </li>
                <li>Ideal for textures, sprites, and digital art</li>
                <li>Lossless quality for visual effects</li>
                <li>Widely supported in 3D modeling tools</li>
                <li>Reliable for professional post-production workflows</li>
              </ul>
            </p>

            <p>
              <strong>Pro Tip:</strong> Use TGA for texture maps or transparent
              overlays in game design. For web delivery, convert to PNG or WEBP
              for faster performance.
            </p>

            <p>
              Download <strong>free TGA sample files</strong> from our website
              to test texture loading in game engines, check alpha channel
              support in software, or for use in legacy applications. Ideal for
              <strong>
                {" "}
                game developers, 3D artists, and graphic designers
              </strong>
              .
            </p>
          </article>
        ),
      };

    // ----------------- Videos -----------------
    case "3gp":
      return {
        title: "Sample 3GP video download - Free Mobile Video Sample Files",
        screenTitle: "Sample 3gp video download",
        description:
          "Download a sample 3GP file for testing mobile video playback. Free 3GP sample.",
        keywords:
          "sample 3gp, 3gp file download, 3gpp video example, mobile video format, multimedia container",
        bodyText: (
          <article>
            <p>
              The <strong>3GP</strong> file format, developed by the
              <strong> 3rd Generation Partnership Project (3GPP)</strong>, was
              created to enable efficient
              <strong> video and audio storage</strong> on mobile devices.
              Designed during the early era of 3G mobile technology, it quickly
              became the default recording format for feature phones and early
              smartphones. The primary goal of 3GP was to provide a lightweight,
              compact multimedia format suitable for
              <strong> low-bandwidth networks</strong> and limited device
              storage.
            </p>
            <p>
              This format was historically the standard for
              <strong>recording and sharing video on feature phones</strong>and
              is still used for MMS messaging. While largely superseded by MP4
              on modern smartphones, 3GP remains relevant for testing legacy
              mobile device compatibility. Although the format is gradually
              being replaced by MP4 in modern smartphones, it remains popular
              among developers, testers, and researchers working on
              <strong> legacy mobile applications</strong> and
              <strong> video playback systems</strong>.
            </p>
            <p>
              <strong>Pro Tip:</strong> Developers can use tools like
              <strong> FFmpeg</strong> to convert 3GP files to MP4 or WebM for
              modern compatibility. This ensures smooth playback on current
              browsers and media players without data loss.
            </p>
            <p>
              <strong>Advantages:</strong> 3GP files are
              <strong> lightweight</strong>, <strong>fast to upload</strong>,
              and <strong>optimized for mobile devices</strong>. They’re
              especially useful for performance testing, mobile optimization,
              and ensuring backward compatibility in older Android systems.
              Whether you’re testing a <strong>mobile video player</strong>,
              simulating <strong>low network bandwidth</strong>, or creating
              sample media for an emulator, 3GP files remain an essential
              resource. You can <strong>download sample 3GP videos</strong> to
              test playback and compression behavior across devices.
            </p>

            <p>
              Download <strong>free 3GP sample files</strong> from our website
              to test video playback on older mobile devices, verify
              compatibility with media players, or for use in application
              testing. A useful resource for
              <strong>
                {" "}
                mobile developers, QA testers, and multimedia archivists
              </strong>
              .
            </p>
          </article>
        ),
      };
    case "mp4":
      return {
        title: "Sample mp4 Video Download - Free Sample Files",
        screenTitle: "Sample mp4 video download",
        description:
          "Download a sample MP4 video file for playback and testing. Free MP4 example available.",
        keywords:
          "sample mp4, mp4 video download, mp4 file example, free mp4 video",
        bodyText: (
          <article>
            <p>
              The <strong>MP4</strong> format (<strong>MPEG-4 Part 14</strong>)
              is the most widely used <strong>digital video format</strong> in
              the world. It’s known for offering the perfect balance between{" "}
              <strong>high-quality playback</strong> and
              <strong> efficient compression</strong>. Originally introduced by
              the Moving Picture Experts Group, MP4 quickly became the standard
              for <strong>online streaming</strong>,
              <strong> video editing</strong>, and
              <strong> mobile playback</strong>.
            </p>
            <p>
              MP4 supports
              <strong>
                {" "}
                video, audio, subtitles, metadata, and thumbnails{" "}
              </strong>
              within a single container file. It typically uses the
              <strong> H.264</strong> or <strong> H.265 (HEVC)</strong> codec to
              ensure smooth streaming and optimal storage usage. Because of its
              universal compatibility, MP4 is supported by every major platform—
              <strong> YouTube, Facebook, Instagram,</strong> and
              <strong> TikTok</strong> all rely heavily on MP4-based delivery.
            </p>

            <p>
              <strong>Advantages:</strong> MP4 offers
              <strong> excellent compression efficiency</strong>,
              <strong> universal playback support</strong>, and
              <strong> high-quality visuals</strong>. It supports up to 8K
              resolution and integrates seamlessly with browsers, making it
              perfect for both streaming and local storage.
            </p>
            <p>
              <strong>Pro Tip:</strong> When exporting videos from an editor,
              select MP4 with <strong> H.264 codec</strong> for best results. It
              provides the best trade-off between file size and visual clarity,
              making it ideal for websites, social media, and
              <strong> cross-platform testing</strong>.
            </p>
            <p>
              You can easily
              <strong> download sample MP4 files</strong> to check
              compatibility, codec behavior, and playback speed on various
              devices.
            </p>
          </article>
        ),
      };
    case "mov":
      return {
        title: "Sample mov Video Download - Free Sample Files",
        screenTitle: "Sample mov video download",
        description:
          "Download a sample MOV video file for playback testing. Free MOV example file.",
        keywords: "sample mov, mov video download, mov file example, free mov",
        bodyText: (
          <article>
            <p>
              The <strong>MOV</strong> file format, developed by
              <strong> Apple Inc.</strong>, is the native video format for
              <strong> QuickTime</strong>. It’s a professional-grade multimedia
              container that can store
              <strong> video, audio, and text tracks</strong> in high quality.
              MOV files are popular among filmmakers, video editors, and
              creators who work with high-resolution footage.
            </p>
            <p>
              MOV files often use <strong>H.264</strong>,
              <strong> HEVC (H.265)</strong>, or <strong>ProRes</strong> codecs,
              which deliver crisp quality suitable for post-production
              workflows. Although designed for macOS and iOS systems, MOV is
              widely supported across Windows platforms and most editing
              software like <strong>Final Cut Pro</strong>,
              <strong> Adobe Premiere Pro</strong>, and
              <strong> DaVinci Resolve</strong>. For developers testing{" "}
              <strong>Apple video playback</strong> or users comparing editing
              formats,
              <strong> sample MOV files</strong> are ideal. They help evaluate
              codec performance, frame rate, and cross-platform conversion
              results.
            </p>

            <p>
              <strong>Advantages:</strong> MOV supports
              <strong> lossless video quality</strong>,
              <strong> multiple tracks</strong>, and precise metadata. It’s the
              preferred choice for professionals who require detailed color
              accuracy and minimal compression artifacts.
            </p>
            <p>
              <strong>Pro Tip:</strong> Use the MOV format while editing and
              exporting in high quality. Before publishing, convert the final
              video to MP4 to reduce size and ensure playback compatibility
              across devices.
            </p>

            <p>
              You can <strong>download MOV files free from our website</strong>,
              making them accessible for
              <strong> testing, learning, and creative projects</strong>.
              <strong> MOV remains a widely trusted format</strong> in its
              category.
            </p>
          </article>
        ),
      };
    case "avi":
      return {
        title: "Sample AVI Video Download - Free Sample Files",
        screenTitle: "Sample avi video download",
        description:
          "Download a sample AVI video file for testing playback compatibility. Free AVI sample.",
        keywords:
          "sample avi, avi video download, avi file example, free avi video",
        bodyText: (
          <article>
            <p>
              The <strong>AVI</strong> (Audio Video Interleave) format,
              introduced by <strong>Microsoft</strong> in 1992, is one of the
              earliest and most reliable <strong>video file formats</strong>. It
              uses a straightforward container structure that stores video and
              audio data synchronously, making it a staple for
              <strong> Windows media systems</strong> and video recording
              applications.
            </p>
            <p>
              AVI supports a wide range of codecs but generally offers less
              compression than modern formats like MP4. This means larger file
              sizes but often <strong>higher quality</strong> output. It’s
              frequently used in <strong>raw video capture</strong>,
              <strong> editing workflows</strong>, and software that demands
              precise playback synchronization. Whether you're maintaining
              legacy systems or verifying video encoding performance, AVI files
              are invaluable for testing media pipelines and compression
              quality.
            </p>

            <p>
              <strong>Advantages:</strong> Excellent playback stability, high
              fidelity, and robust legacy support. Developers often use
              <strong> sample AVI files</strong> to test codecs, player
              compatibility, and data streaming efficiency.
            </p>
            <p>
              <strong>Pro Tip:</strong> For best results, use AVI for editing or
              testing uncompressed video. Once final, convert to MP4 for smaller
              file sizes and broader compatibility.
            </p>

            <p>
              You can <strong>download AVI files free from our website</strong>,
              making them accessible for
              <strong> testing, learning, and creative projects</strong>.
              <strong> AVI remains a widely trusted format</strong> in its
              category.
            </p>
          </article>
        ),
      };
    case "flv":
      return {
        title: "Sample flv Video Download - Free Sample Files",
        screenTitle: "Sample flv video download",
        description:
          "Free sample FLV video file for testing Flash Video compatibility. Download instantly.",
        keywords: "sample flv, flv video download, flv file example, free flv",
        bodyText: (
          <article>
            <p>
              <strong>FLV file</strong> is a video format for web streaming.
              Introduced in 2002 by Macromedia, it has become a standard in its
              category for
              <strong>quality, compatibility, and efficiency</strong>. FLV files
              are widely used across
              <strong> professional, educational, and personal projects</strong>
              .
            </p>
            <p>
              The <strong>FLV</strong> (Flash Video) format was once the
              standard for <strong>online video streaming</strong> during the
              early days of the internet. It powered major video platforms such
              as <strong>YouTube</strong>, <strong>Dailymotion</strong>, and{" "}
              <strong>Vimeo</strong> before the rise of HTML5 video. Developed
              for Adobe Flash Player, FLV uses
              <strong> Sorenson Spark</strong> or <strong>VP6 codecs</strong>
              to deliver small, fast-loading video files.
            </p>
            <p>
              While Flash technology has been discontinued, FLV files remain
              valuable for <strong> legacy content testing</strong>,
              <strong> offline archives</strong>, and
              <strong> compatibility validation</strong> in older systems.
              Developers often use FLV when testing conversion tools or
              upgrading old media to newer formats. If you’re restoring old
              media or developing playback software,
              <strong>sample FLV files</strong> are useful for testing decoders,
              migration pipelines, and format conversion accuracy.
            </p>

            <p>
              <strong>Advantages:</strong> Small file size, efficient streaming,
              and historical relevance. Although outdated, FLV still helps in
              backward compatibility checks and data migration projects.
            </p>
            <p>
              <strong>Pro Tip:</strong> Use <strong>FFmpeg</strong> or
              <strong> HandBrake</strong> to convert FLV to MP4 or WEBM. This
              preserves visual quality while making videos compatible with
              modern players and browsers.
            </p>

            <p>
              You can
              <strong> download FLV files free from our website</strong>, making
              them accessible for
              <strong> testing, learning, and creative projects</strong>.
              <strong> FLV remains a widely trusted format</strong> in its
              category.
            </p>
          </article>
        ),
      };
    case "webm":
      return {
        title: "Sample webm Video Download - Free Sample Files",
        screenTitle: "Sample webm video download",
        description:
          "Get a free sample WEBM video file for testing HTML5 playback and browsers.",
        keywords:
          "sample webm, webm video download, webm file example, free webm",
        bodyText: (
          <article>
            <p>
              <strong>WEBM file</strong> is a video format for HTML5 streaming.
              Introduced in 2010 by Google, it has become a standard in its
              category for{" "}
              <strong>quality, compatibility, and efficiency</strong>. WEBM
              files are widely used across{" "}
              <strong>professional, educational, and personal projects</strong>.
              It provides high-quality video with excellent compression
              efficiency, making it ideal for{" "}
              <strong>HTML5 video playback</strong> and{" "}
              <strong>SEO-optimized websites</strong>.
            </p>
            <p>
              All major browsers—including <strong>Chrome</strong>,{" "}
              <strong>Firefox</strong>, and <strong>Edge</strong>—natively
              support WEBM, ensuring smooth performance without extra plugins.
              Its smaller file sizes help pages load faster, improving user
              experience and search rankings.
            </p>

            <p>
              <strong>Advantages:</strong> Free to use, lightweight, and
              optimized for streaming. WEBM boosts <strong>page speed</strong>{" "}
              and <strong>core web vitals</strong>, key factors for search
              engine visibility.
            </p>
            <p>
              <strong>Pro Tip:</strong> Use WEBM for video backgrounds,
              tutorials, and previews. It’s the most efficient format for
              embedding videos in web pages without impacting performance or
              SEO.
            </p>
            <p>
              You can <strong>download WEBM files free from our website</strong>
              , making them accessible for{" "}
              <strong>testing, learning, and creative projects</strong>.{" "}
              <strong>WEBM remains a widely trusted format</strong> in its
              category.
            </p>
          </article>
        ),
      };
    case "mkv":
      return {
        title: "Sample mkv Video Download - Free Sample Files",
        screenTitle: "Sample mkv video download",
        description:
          "Free sample MKV video file available for testing video players and formats.",
        keywords: "sample mkv, mkv video download, mkv file example, free mkv",
        bodyText: (
          <article>
            <p>
              <strong>MKV (Matroska Video)</strong> file is a flexible{" "}
              <strong>multimedia container format</strong> capable of holding
              multiple <strong>video, audio, and subtitle tracks</strong> in a
              single file. Introduced in 2002, the{" "}
              <strong>Matroska format</strong> was designed as an open standard
              alternative to other containers, offering support for
              high-definition video and advanced multimedia features.{" "}
              <strong>MKV files</strong> are widely used for storing movies, TV
              shows, and complex video projects due to their versatility and
              support for a variety of codecs.
            </p>

            <p>
              <em>MKV files</em> are compatible with most media players, though
              some may require additional codecs. You can{" "}
              <strong>download MKV files free from our website</strong>,
              allowing users to explore, test, or use them in personal and
              professional video projects.{" "}
              <strong>MKV remains a trusted format</strong> for robust,
              high-quality <strong>video containers</strong>.
            </p>
            <p>
              The <strong>MKV</strong> or <strong>Matroska Video</strong> format
              is a flexible and open-source multimedia container that can hold{" "}
              <strong>video, audio, subtitles, and metadata</strong> in one
              file. Unlike MP4 or MOV, MKV supports an unlimited number of
              tracks and is designed for long-term preservation of high-quality
              media.
            </p>

            <p>
              <strong>Advantages:</strong> MKV is{" "}
              <strong>free, highly customizable</strong>, and{" "}
              <strong>future-proof</strong>. It’s ideal for developers testing
              video libraries, archivists preserving content, or anyone wanting
              advanced media control.
            </p>
            <p>
              <strong>Pro Tip:</strong> Use MKV when you want to store multiple
              audio languages or subtitle options in a single file. For browser
              playback or online sharing, convert it to MP4 or WebM for
              compatibility without losing quality.
            </p>
            <p>
              You can <strong>download sample MKV videos</strong> to test
              multi-track playback, compression efficiency, and subtitle
              integration on various media players.
            </p>
          </article>
        ),
      };

    // ----------------- Audio -----------------
    case "mp3":
      return {
        title: "Sample mp3 audio file Download - Free Sample Files",
        screenTitle: "Sample mp3 audio download",
        description:
          "Download a sample MP3 audio file for playback and audio testing. Free MP3 sample provided.",
        keywords:
          "sample mp3, mp3 audio download, mp3 file example, free mp3 song",
        bodyText: (
          <article>
            <p>
              The <strong>.MP3</strong> file is the{" "}
              <strong>original digital music standard</strong>, born in 1993 and
              dominant through the iPod era — the file you ripped from CDs,
              loaded onto your Diamond Rio, or shared on Napster. It powers
              billions of playlists, podcasts, and ringtones that still play
              everywhere today.
            </p>

            <p>
              An .MP3 supports{" "}
              <strong>
                bitrates from 32 to 320 kbps, stereo or mono, ID3 tags for
                artist/album art, and even basic lyrics
              </strong>{" "}
              — everything you needed for portable tunes back then. While
              surpassed by lossless formats,{" "}
              <strong>
                every device, car stereo, and smart speaker still plays MP3
              </strong>{" "}
              without plugins. It’s the default in{" "}
              <strong>music libraries</strong> and{" "}
              <strong>legacy media servers</strong> where compatibility trumps
              quality.
            </p>

            <p>
              <strong>How to open:</strong> Use <strong>VLC</strong> (free),{" "}
              <strong>Windows Media Player</strong>, or upload to{" "}
              <strong>Spotify/YouTube</strong>.<strong>Can’t open?</strong> Try
              a different player or convert to WAV.<br></br>
              <strong>How to create:</strong> Open Audacity → Export → select
              “MP3 Files”.<br></br>
              <strong>Pro tip:</strong> Use 192+ kbps for good quality; lower
              rates sound tinny on modern headphones.
            </p>

            <p>
              Though lossy, .MP3 is <strong>rock-solid on old hardware</strong>{" "}
              and opens instantly in any media player. It’s tiny compared to WAV
              and ideal for <strong>mobile music and voice recordings</strong>.
            </p>

            <section>
              <h5>Why .MP3 Still Matters</h5>
              <ul>
                <li>
                  <strong>Plays on 25-Year-Old Devices:</strong> No
                  compatibility issues
                </li>
                <li>
                  <strong>Super Small & Fast:</strong> 1 song ≈ 4 MB
                </li>
                <li>
                  <strong>Universal Everywhere:</strong> Phones, cars, TVs,
                  watches
                </li>
                <li>
                  <strong>No Bloat:</strong> Just audio + tags
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .MP3 sample files</strong> to test players,
              metadata editors, or conversion tools. Perfect for DJs,
              podcasters, and IT teams managing old music archives.
            </p>
          </article>
        ),
      };
    case "aac":
      return {
        title: "Sample aac audio file Download - Free Sample Files",
        screenTitle: "Sample aac audio download",
        description:
          "Free sample AAC audio file for testing playback on different devices.",
        keywords: "sample aac, aac audio download, aac file example, free aac",
        bodyText: (
          <article>
            <p>
              The <strong>.AAC</strong> file is the{" "}
              <strong>successor to MP3</strong>, launched in 1997 and refined
              for the iPhone era — the file inside your Apple Music library,
              Nintendo Switch games, or 4K YouTube videos. It’s behind
              crystal-clear podcasts and Dolby Atmos tracks.
            </p>

            <p>
              An .AAC supports{" "}
              <strong>
                up to 48 kHz, 8-channel surround, DRM protection, and HE-AAC for
                ultra-low bitrates
              </strong>{" "}
              — everything needed for pro audio today. While not as universal as
              MP3,{" "}
              <strong>
                every smartphone, smart TV, and streaming platform supports AAC
                natively
              </strong>
              . It’s standard in <strong>broadcasting</strong> and{" "}
              <strong>mobile games</strong>.
            </p>

            <p>
              <strong>How to open:</strong> Use{" "}
              <strong>iTunes/Apple Music</strong>, <strong>VLC</strong>, or{" "}
              <strong>Foobar2000</strong>.<strong>Can’t open?</strong> Rename
              .m4a to .aac or convert.<br></br>
              <strong>How to create:</strong> iTunes → Preferences → Import
              Settings → AAC Encoder.<br></br>
              <strong>Pro tip:</strong> 256 kbps AAC sounds better than 320 kbps
              MP3.
            </p>

            <p>
              Efficient and clean, .AAC is{" "}
              <strong>optimized for modern devices</strong> and streams
              flawlessly. Smaller than MP3 at equal quality, perfect for{" "}
              <strong>wireless earbuds and cloud libraries</strong>.
            </p>

            <section>
              <h5>Why .AAC Still Matters</h5>
              <ul>
                <li>
                  <strong>Superior Quality at Low Bitrates:</strong> Ideal for
                  streaming
                </li>
                <li>
                  <strong>Native in iOS/Android:</strong> Zero conversion needed
                </li>
                <li>
                  <strong>Supports Surround & DRM:</strong> Movies, games,
                  rentals
                </li>
                <li>
                  <strong>Efficient Compression:</strong> Saves
                  storage/bandwidth
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .AAC sample files</strong> to test encoders,
              streaming setups, or metadata tools. Perfect for developers,
              streamers, and mobile audio workflows.
            </p>
          </article>
        ),
      };
    case "wav":
      return {
        title: "Sample wav audio file Download - Free Sample Files",
        screenTitle: "Sample wav audio download",
        description:
          "Download a sample WAV audio file for testing uncompressed audio. Free WAV file available.",
        keywords:
          "sample wav, wav audio download, wav file example, free wav music",
        bodyText: (
          <article>
            <p>
              <strong>WAV file</strong> is a uncompressed audio format.
              Introduced in 1991 by Microsoft and IBM, it has become a standard
              in its category for{" "}
              <strong>quality, compatibility, and efficiency</strong>. WAV files
              are widely used across{" "}
              <strong>professional, educational, and personal projects</strong>.
            </p>
            <p>
              <strong>WAV</strong> is the uncompressed, lossless audio format
              from Windows — raw CD-quality sound in a simple container. The
              gold standard for editing and pro audio.
            </p>
            <p>
              A .WAV supports{" "}
              <strong>
                up to 192 kHz/32-bit, multichannel, and metadata chunks
              </strong>{" "}
              — perfect fidelity with zero compression.{" "}
              <strong>Every audio editor and OS plays WAV natively</strong>.
              Essential in <strong>music production</strong> and{" "}
              <strong>forensic audio</strong>.
            </p>

            <p>
              <strong>How to open:</strong> Use{" "}
              <strong>any media player or DAW</strong>.
              <strong>Can’t open?</strong> Check bit depth; convert if needed.
              <br></br>
              <strong>How to create:</strong> Record in Audacity → Export → WAV.
              <br></br>
              <strong>Pro tip:</strong> Use 44.1 kHz/16-bit for CD quality;
              higher for pro work.
            </p>

            <p>
              Pure and simple, .WAV is <strong>rock-solid for editing</strong>.
              Huge files, but perfect for{" "}
              <strong>archival and mastering</strong>.
            </p>

            <section>
              <h5>Why .WAV Still Matters</h5>
              <ul>
                <li>
                  <strong>Zero Quality Loss:</strong> Edit without degradation
                </li>
                <li>
                  <strong>Universal in Pro Audio:</strong> DAWs, plugins,
                  hardware
                </li>
                <li>
                  <strong>No Codecs Needed:</strong> Opens anywhere
                </li>
                <li>
                  <strong>Supports High-Res:</strong> 24/96, DSD, etc.
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .WAV sample files</strong> to test editing,
              plugins, or archival workflows. Perfect for producers, sound
              designers, and audio engineers.
            </p>
          </article>
        ),
      };
    case "ogg":
      return {
        title: "Sample ogg Audio file Download - Free Sample Files",
        screenTitle: "Sample ogg audio download",
        description:
          "Free sample OGG audio file for testing compatibility with media players.",
        keywords: "sample ogg, ogg audio download, ogg file example, free ogg",
        bodyText: (
          <article>
            <p>
              The <strong>.OGG</strong> file is the{" "}
              <strong>open-source audio rebel</strong>, launched in 1993 to
              fight MP3 patents — the format in Spotify’s web player, Minecraft
              sounds, and indie game engines. It’s the choice of developers who
              hate licensing fees. OGG files are widely used across{" "}
              <strong>professional, educational, and personal projects</strong>.
            </p>

            <p>
              An .OGG supports{" "}
              <strong>
                variable bitrate, multichannel audio, metadata tagging, and
                lossless-like quality at 160 kbps
              </strong>{" "}
              — everything audiophiles want without royalties.{" "}
              <strong>Firefox, Chrome, and Unity play OGG natively</strong>.
              Common in <strong>HTML5 games</strong> and{" "}
              <strong>open-source software</strong>.
            </p>

            <p>
              <strong>How to open:</strong> Use <strong>VLC</strong>,{" "}
              <strong>Foobar2000</strong>, or browser playback.
              <strong>Can’t open?</strong> Install codecs or convert to MP3.
              <br></br>
              <strong>How to create:</strong> Audacity → Export → Ogg Vorbis.
              <br></br>
              <strong>Pro tip:</strong> Use quality setting 5–7 for best
              size/quality balance.
            </p>

            <p>
              Free and flexible, .OGG is{" "}
              <strong>perfect for web and indie dev</strong>. Smaller than MP3
              at same quality, ideal for{" "}
              <strong>game audio loops and open projects</strong>.
            </p>

            <section>
              <h5>Why .OGG Still Matters</h5>
              <ul>
                <li>
                  <strong>Royalty-Free:</strong> No licensing headaches
                </li>
                <li>
                  <strong>Web-Native:</strong> Streams in browsers
                </li>
                <li>
                  <strong>Great for Games:</strong> Loops cleanly
                </li>
                <li>
                  <strong>Open Standard:</strong> Future-proof
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .OGG sample files</strong> to test game
              engines, web audio, or open-source players. Perfect for developers
              and FOSS enthusiasts.
            </p>
          </article>
        ),
      };
    case "aiff":
      return {
        title:
          "Sample AIFF audio file download - Free Uncompressed Audio Sample Files",
        screenTitle: "Sample aiff download",
        description:
          "Download a sample AIFF file for testing CD-quality audio. Free AIFF sample.",
        keywords:
          "sample aiff, aiff file download, audio interchange file format, uncompressed audio example, mac audio sample",
        bodyText: (
          <article>
            <p>
              <strong>AIFF (Audio Interchange File Format)</strong> is an{" "}
              <strong>uncompressed, high-quality audio format</strong> developed
              by Apple. It stores CD-quality audio (44.1 kHz, 16-bit) without
              any data loss, similar to a WAV file but primarily used within the
              Apple ecosystem.
            </p>

            <p>
              This format is widely used in{" "}
              <strong>
                professional audio production, music mastering, and on Mac
                systems
              </strong>{" "}
              where fidelity is paramount. AIFF files deliver pristine audio
              reproduction, making them a standard for recording and archiving
              original audio tracks. The <strong>.AIFF</strong> file is the{" "}
              <strong>Mac’s answer to WAV</strong>, launched in 1988 — the
              format in Logic Pro sessions, Final Cut audio, and old Mac chime
              sounds. It’s CD-quality audio with Apple flair.
            </p>

            <p>
              An .AIFF supports{" "}
              <strong>high sample rates, loop points, and rich metadata</strong>{" "}
              — same fidelity as WAV.{" "}
              <strong>
                Every Mac DAW and most pro apps read AIFF natively
              </strong>
              . Common in <strong>film post-production</strong> and{" "}
              <strong>Apple Loops</strong>.
            </p>

            <p>
              <strong>How to open:</strong> Use <strong>QuickTime</strong>,{" "}
              <strong>Logic</strong>, or <strong>VLC</strong>.
              <strong>Can’t open?</strong> Convert to WAV.<br></br>
              <strong>How to create:</strong> Logic → Bounce → AIFF.<br></br>
              <strong>Pro tip:</strong> AIFF-C adds compression if needed
              (rarely used).
            </p>

            <p>
              Clean and reliable, .AIFF is{" "}
              <strong>Mac-native but cross-compatible</strong>. Large files,
              ideal for <strong>studio interchange</strong>.
            </p>

            <section>
              <h5>Why .AIFF Still Matters</h5>
              <ul>
                <li>
                  <strong>Mac-Optimized Metadata:</strong> Loops, markers
                </li>
                <li>
                  <strong>Proven in Film/TV:</strong> Post-production standard
                </li>
                <li>
                  <strong>Lossless & Edit-Ready:</strong> No generation loss
                </li>
                <li>
                  <strong>Interchange Format:</strong> Mac ↔ PC
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .AIFF sample files</strong> to test Logic
              libraries, video editing, or Mac audio workflows. Perfect for
              composers and video editors.
            </p>
          </article>
        ),
      };
    case "flac":
      return {
        title:
          "Sample flac audio file download - Free Lossless Audio Sample Files",
        screenTitle: "Sample flac audio download",
        description:
          "Download a sample FLAC file for testing high-fidelity audio. Free FLAC sample.",
        keywords:
          "sample flac, flac file download, lossless audio example, free flac sample, high resolution audio",
        bodyText: (
          <article>
            <p>
              <strong>FLAC (Free Lossless Audio Codec)</strong> is a{" "}
              <strong>lossless audio compression format</strong> that reduces
              file size without sacrificing any audio quality. Unlike lossy
              formats like MP3, FLAC preserves the original sound data
              perfectly.
            </p>

            <p>
              This format is the preferred choice for{" "}
              <strong>
                audiophiles, music archivists, and audio professionals
              </strong>{" "}
              who require pristine sound quality. FLAC files provide a perfect
              copy of the source material, making them ideal for critical
              listening and long-term preservation of music collections.
            </p>

            <p>
              The <strong>.FLAC</strong> file is the{" "}
              <strong>lossless compression king</strong>, launched in 2001 — the
              format in high-res downloads, Bandcamp albums, and audiophile
              torrents. It’s WAV quality, zipped. A .FLAC supports{" "}
              <strong>
                up to 384 kHz/32-bit, multichannel, embedded cuesheets, and
                replaygain
              </strong>{" "}
              — perfect archival.{" "}
              <strong>Supported by most hi-fi players and software</strong>.
              Standard in <strong>music archiving</strong> and{" "}
              <strong>vinyl rips</strong>.
            </p>

            <p>
              <strong>How to open:</strong> Use <strong>Foobar2000</strong>,{" "}
              <strong>VLC</strong>, or <strong>Android/iOS apps</strong>.
              <strong>Can’t open?</strong> Update player or convert.<br></br>
              <strong>How to create:</strong> Foobar → Convert → FLAC.<br></br>
              <strong>Pro tip:</strong> Level 5 compression is fast and
              efficient.
            </p>

            <p>
              Efficient and pure, .FLAC is{" "}
              <strong>half the size of WAV, full quality</strong>. Perfect for{" "}
              <strong>backups and streaming high-res</strong>.
            </p>

            <section>
              <h5>Why .FLAC Still Matters</h5>
              <ul>
                <li>
                  <strong>Lossless + Small:</strong> Best of both worlds
                </li>
                <li>
                  <strong>Open Source:</strong> No patents
                </li>
                <li>
                  <strong>Hi-Res Ready:</strong> 24/192, DSD
                </li>
                <li>
                  <strong>Tagging & Cues:</strong> Album rips done right
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .FLAC sample files</strong> to test
              playback, tagging, or archival tools. Perfect for audiophiles,
              archivists, and music collectors.
            </p>
          </article>
        ),
      };

    // ----------------- Documents -----------------
    case "pdf":
      return {
        title: "Sample pdf file - Free pdf Files for Testing",
        screenTitle: "Sample pdf download",
        description:
          "Download a sample PDF document for testing. Free sample PDF file provided instantly.",
        keywords:
          "sample pdf, pdf download, pdf file example, free pdf document",
        bodyText: (
          <article>
            <p>
              The <strong>PDF (Portable Document Format)</strong> is the world's
              most trusted file format for documents, designed to preserve
              formatting across all devices and operating systems. Whether you
              use
              <strong> Windows, Mac, iOS, Android, or Linux</strong>, a PDF file
              displays exactly as intended—unlike Word or PowerPoint files,
              which often shift layouts between apps.
            </p>

            <p>
              Developed by <strong>Adobe</strong> and now an open{" "}
              <strong>ISO standard</strong>, PDFs support interactive elements
              like hyperlinks, fillable forms, digital signatures, and even
              embedded videos. Professionals rely on PDFs for resumes,
              contracts, eBooks, and invoices because they guarantee print-ready
              quality and secure sharing (with password protection and
              encryption). Students, businesses, and government agencies use
              free PDF readers like
              <strong> Adobe Acrobat</strong> to view these files without
              compatibility issues.
            </p>

            <p>
              Unlike <strong>JPEGs</strong> or <strong>DOCs</strong>, a PDF
              document maintains text clarity at any zoom level and embeds fonts
              so designs appear identical on every device.
              <strong> Download free PDF samples</strong> to test its
              versatility—or create your own using "Print → Save as PDF" in any
              app.
            </p>

            <section>
              <h5>Key Benefits of PDF Format</h5>
              <ul>
                <li>
                  <strong>Universal Compatibility:</strong> Looks perfect on
                  Windows, Mac, iOS, Android, and Linux
                </li>
                <li>
                  <strong>Professional Security:</strong> Add passwords,
                  encryption, and digital signatures
                </li>
                <li>
                  <strong>Interactive Elements:</strong> Fillable forms,
                  clickable links, and embedded videos
                </li>
                <li>
                  <strong>Print-Ready Quality:</strong> Fonts and layouts stay
                  exactly as designed
                </li>
                <li>
                  <strong>Easy to Create & Share:</strong> Save as PDF from any
                  app; compress for email
                </li>
              </ul>
            </section>

            <p>
              💡 <strong>Pro Tip:</strong> Always send important files as
              PDF—your recipient will thank you for the clean, professional
              look.
            </p>
          </article>
        ),
      };
    case "ppt":
      return {
        title: "Sample ppt file Download - Free Sample Files",
        screenTitle: "Sample ppt download",
        description:
          "Free sample PPT presentation file for testing slides and office software.",
        keywords: "sample ppt, ppt download, ppt file example, free ppt",
        bodyText: (
          <article>
            <p>
              The <strong>.PPT</strong> file is the{" "}
              <strong>original PowerPoint format</strong> from 1987 to 2003 —
              the file behind every school project, sales pitch, and family
              reunion slideshow from the dial-up era. It’s simple, reliable, and
              still works on computers over 20 years old.
            </p>

            <p>
              It supports{" "}
              <strong>
                text animations, clipart, sound effects, and slide transitions
              </strong>{" "}
              — think flying bullets and “whoosh” sounds. While it lacks modern
              4K or 3D, it’s{" "}
              <strong>perfect for lightweight presentations</strong> and{" "}
              <strong>legacy corporate templates</strong>. Many companies still
              use .PPT because their projectors or old laptops only read it.
            </p>
            <p>
              <strong>Pro tips:</strong>- <strong>Avoid embedded fonts</strong>{" "}
              — use Arial or Times New Roman. -{" "}
              <strong>Convert to .pptx</strong> for new work — smaller and
              safer. - <strong>Email safely</strong> — zip or export as PDF. -{" "}
              <strong>Fix broken links</strong> — re-embed images manually.
            </p>

            <p>
              .PPT files are <strong>tiny</strong> (10 slides = ~500 KB) and{" "}
              <strong>bulletproof on legacy systems</strong>. Ideal for{" "}
              <strong>
                simple training, archives, or low-bandwidth sharing
              </strong>
              .
            </p>

            <section>
              <h5>Why .PPT Still Rules Retro Decks</h5>
              <ul>
                <li>
                  <strong>Works on Windows 98:</strong> And every OS since
                </li>
                <li>
                  <strong>Lightning Fast:</strong> Loads in 1 second
                </li>
                <li>
                  <strong>Trusted in Business:</strong> 30+ years of use
                </li>
                <li>
                  <strong>No Bloat:</strong> Just slides and basic effects
                </li>
                <li>
                  <strong>Perfect for Archives:</strong> Never goes obsolete
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .PPT sample files</strong> to test old
              templates, retro animations, or legacy projectors. Great for
              teachers reviving 2000s lessons or IT teams supporting vintage
              hardware.
            </p>
          </article>
        ),
      };
    case "pptx":
      return {
        title: "Sample pptx file Download - Free Sample Files",
        screenTitle: "Sample pptx download",
        description:
          "Free sample PPTX presentation file for testing slides and office software.",
        keywords: "sample pptx, pptx download, pptx file example, free ppt",
        bodyText: (
          <article>
            <p>
              <strong>PPTX file</strong> is a PowerPoint presentation format.
              Introduced in 2007 Office Open XML, it has become a standard in
              its category for{" "}
              <strong>quality, compatibility, and efficiency</strong>. PPTX
              files are widely used across{" "}
              <strong>professional, educational, and personal projects</strong>.
            </p>
            <p>
              Imagine a TED Talk: smooth morph transitions, 3D spinning models,
              live subtitles in Spanish — all in one file. That’s{" "}
              <strong>.PPTX</strong> — the <b>modern PowerPoint format</b> that
              turns ideas into cinematic experiences. Introduced in 2007, it’s
              smaller, safer, and built for the smartphone age.
            </p>

            <p>
              A .PPTX file supports{" "}
              <b>
                AI design suggestions, 4K images, embedded videos, reusable
                themes, and real-time co-editing
              </b>
              . Add <b>speaker notes, handouts, or record narration</b> — all
              saved together. Teachers use it for interactive quizzes; marketers
              use it for clickable prototypes; startups use it to raise
              millions.
            </p>

            <p>
              <strong>Pro tips:</strong>- <b>Reuse slides</b> — copy from old
              decks in one click. - <b>Export as MP4</b> — share with anyone, no
              software needed. - <b>Compress media</b> — keep file under 50 MB.
              - <b>Live captions</b> — turn on during presentation for
              accessibility.
            </p>

            <p>
              PPTX is <b>cloud-native</b> — edit on phone, tablet, or browser.
              It’s <b>macro-free by default</b> and <b>50% smaller</b> than
              .PPT.
            </p>

            <section>
              <h5>Why PPTX Wins Every Pitch</h5>
              <ul>
                <li>
                  <strong>Cinematic Effects:</strong> Morph, 3D, video
                  backgrounds
                </li>
                <li>
                  <strong>AI Design:</strong> Pro slides in 10 seconds
                </li>
                <li>
                  <strong>Live Translation:</strong> Auto-subtitles in 60+
                  languages
                </li>
                <li>
                  <strong>Record & Share:</strong> Add voiceover and timing
                </li>
                <li>
                  <strong>Cloud Sync:</strong> Edit from anywhere
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .PPTX sample files</strong> to test
              animations, 3D models, or video exports. Perfect for speakers,
              educators, and designers who want to wow audiences.
            </p>
          </article>
        ),
      };
    case "doc":
      return {
        title: "Sample doc file  - Free .doc Files for Testing",
        screenTitle: "Sample doc download",
        description:
          "Download a sample DOC Word file for testing. Free DOC file available.",
        keywords: "sample docx, docx download, docx file example, free docx",
        bodyText: (
          <article>
            <p>
              The <strong>.DOC</strong> file is the{" "}
              <strong>original Microsoft Word format</strong>, used from 1997 to
              2003 — the file you emailed in the early 2000s, saved on floppy
              disks, or printed from Windows XP. It’s the format behind millions
              of resumes, school reports, and office memos that still float
              around today. It’s great for creating and editing text-based files
              like letters, resumes, and reports, with support for formatted
              text, tables, and images.
            </p>

            <p>
              A .DOC file supports{" "}
              <strong>
                bold, italics, tables, images, headers, footers, and even
                clipart
              </strong>{" "}
              — everything you needed for a professional document back then.
              While it’s been replaced by DOCX,{" "}
              <strong>
                many small businesses, schools, and government offices still use
                .DOC
              </strong>{" "}
              because their old software only reads it. It’s also common in{" "}
              <strong>legal archives</strong> and{" "}
              <strong>legacy databases</strong> where upgrading isn’t an option.
            </p>

            <p>
              <strong>How to open:</strong> Use <strong>Microsoft Word</strong>{" "}
              (any version), <strong>LibreOffice</strong> (free), or upload to{" "}
              <strong>Google Docs</strong>.<strong>Can’t open?</strong> Try
              “Open and Repair” in Word or save as .docx to modernize it.
              <br></br>
              <strong>How to create:</strong> Open Word → Save As → select “Word
              97–2003 Document (*.doc)”.<br></br>
              <strong>Pro tip:</strong> Avoid .DOC for new files — it can
              trigger virus scanners due to old macro support. Always scan
              before opening.
            </p>

            <p>
              Though outdated, .DOC is{" "}
              <strong>rock-solid on old computers</strong> and opens instantly
              in nearly any word processor. It’s smaller than DOCX in many cases
              and perfect for <strong>simple, no-frills documents</strong>.
            </p>

            <section>
              <h5>Why .DOC Still Matters</h5>
              <ul>
                <li>
                  <strong>Works on 25-Year-Old PCs:</strong> No compatibility
                  issues
                </li>
                <li>
                  <strong>Lightweight & Fast:</strong> Opens in seconds
                </li>
                <li>
                  <strong>Universal in Old Systems:</strong> HR, legal, and
                  education
                </li>
                <li>
                  <strong>No Bloat:</strong> Just text and basic formatting
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .DOC sample files</strong> to test legacy
              templates, old resumes, or conversion tools. Perfect for students,
              admins, and IT teams managing old archives.
            </p>
          </article>
        ),
      };
    case "docx":
      return {
        title: "Sample docx file - Free .docx Files for Testing",
        screenTitle: "Sample docx download",

        description:
          "Download a sample DOCX Word file for testing. Free DOCX file available.",
        keywords: "sample docx, docx download, docx file example, free docx",
        bodyText: (
          <article>
            <p>
              <strong>DOCX file</strong> is a Word document format. Introduced
              in 2007 Office Open XML, it has become a standard in its category
              for <strong>quality, compatibility, and efficiency</strong>. DOCX
              files are widely used across{" "}
              <strong>professional, educational, and personal projects</strong>.
            </p>

            <p>
              The <strong>.DOCX</strong> file is{" "}
              <strong>today’s standard Word document</strong> — smaller, safer,
              and smarter than the old .DOC. Introduced in 2007, it’s what you
              get when you hit “Save” in Microsoft Word, Google Docs, or
              LibreOffice.
            </p>

            <p>
              It supports{" "}
              <strong>
                real-time co-editing, smart styles, auto-generated tables of
                contents, citations, and cloud sync
              </strong>
              . Because it’s built on XML and ZIP compression, a 10-page report
              can be under 50 KB. Students use it for group essays; lawyers use
              it for version-controlled contracts; businesses use it for branded
              templates.
            </p>

            <p>
              <strong>How to open:</strong> <strong>Microsoft Word</strong>,{" "}
              <strong>Google Docs</strong> (free), <strong>Apple Pages</strong>,
              or <strong>LibreOffice</strong>.<strong>How to create:</strong>{" "}
              Just type and save — .docx is the default.<br></br>
              <strong>How to edit:</strong> Use “Track Changes” for feedback or
              “Focus Mode” to write without distractions.<br></br>
              <strong>Pro tip:</strong> If a file won’t open, right-click →
              “Unblock” (Windows) or unzip it manually to recover text.
            </p>

            <p>
              DOCX is <strong>recoverable</strong> — if corrupted, you can often
              extract the content by renaming to .zip and opening. It’s also{" "}
              <strong>macro-free by default</strong>, making it safer for email.
            </p>

            <section>
              <h5>Why DOCX is the Future of Documents</h5>
              <ul>
                <li>
                  <strong>Live Collaboration:</strong> Edit with 10 people at
                  once
                </li>
                <li>
                  <strong>Smart Formatting:</strong> Change one style, update
                  all
                </li>
                <strong>Cloud-Ready:</strong> Save to OneDrive, edit on phone
                <li>
                  <strong>Small & Secure:</strong> 50% smaller, no macro risks
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .DOCX sample files</strong> to test
              templates, collaboration, or automation. Ideal for writers, teams,
              and educators.
            </p>
          </article>
        ),
      };
    case "xls":
      return {
        title: "Sample xls file - Free .xls Files for Testing",
        screenTitle: "Sample xls download",
        description:
          "Download a sample XLS Excel file for testing. Free XLS file available.",
        keywords: "sample xls, xls download, xls file example, free xls",
        bodyText: (
          <article>
            <p>
              <strong>XLS</strong> is the legacy Microsoft Excel spreadsheet
              format based on BIFF (Binary Interchange File Format). It
              organizes data in rows and columns and supports formulas, basic
              charts, and simple data analysis.
            </p>
            <p>
              It’s 1998. Your dad balances the family budget in a{" "}
              <strong>.XLS</strong> file — the{" "}
              <strong>original Excel format</strong> that ran small businesses,
              tracked grades, and powered inventory for decades. From 1987 to
              2003, .XLS was the only spreadsheet that mattered.
            </p>

            <p>
              An .XLS file supports{" "}
              <strong>formulas, charts, and up to 65,536 rows</strong> — enough
              for most real-world tasks. No XML, no bloat — just pure
              number-crunching.{" "}
              <strong>
                Factories, banks, and accounting software still use .XLS
              </strong>{" "}
              because their machines haven’t been updated since Y2K.
            </p>

            <p>
              <strong>How to open .XLS:</strong>
              1. <strong>Excel</strong> (any version). 2.{" "}
              <strong>LibreOffice Calc</strong> (free). 3.{" "}
              <strong>Google Sheets</strong> — upload.
              <strong>File corrupted?</strong> Open → “Open and Repair”.
              <br></br>
              <strong>How to create:</strong> Old Excel → Save As → .xls.
              <br></br>
              <strong>How to edit:</strong> Same as modern — just skip new
              features.
            </p>

            <p>
              <strong>Pro tips:</strong>- <strong>Avoid macros</strong> — .xls
              supports them, but they’re risky. -{" "}
              <strong>Convert to .xlsx</strong> for new work. -{" "}
              <strong>Fix #REF errors</strong> — check cell references. -{" "}
              <strong>Email safely</strong> — save as CSV or PDF.
            </p>

            <p>
              .XLS files are <strong>lightning-fast</strong> and open on{" "}
              <strong>Windows 95 and up</strong>. Perfect for{" "}
              <strong>
                simple tracking, legacy reports, or low-spec devices
              </strong>
              .
            </p>

            <section>
              <h5>Why .XLS Still Crunches Numbers</h5>
              <ul>
                <li>
                  <strong>Legacy Compatible:</strong> Works in Excel 97–2003
                </li>
                <li>
                  <strong>Super Fast:</strong> No XML overhead
                </li>
                <li>
                  <strong>Trusted in Industry:</strong> 35+ years of use
                </li>
                <li>
                  <strong>Lightweight:</strong> 1,000 rows = ~100 KB
                </li>
                <li>
                  <strong>Simple & Reliable:</strong> No surprises
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .XLS sample files</strong> to test old
              reports, imports, or legacy systems. Great for accountants,
              admins, and IT teams supporting vintage software.
            </p>
          </article>
        ),
      };
    case "xlsx":
      return {
        title: "Sample xlsx file - Free .xlsx Files for Testing",
        screenTitle: "Sample xlsx download",

        description:
          "Download a sample XLSX Excel file for testing. Free XLSX file available.",
        keywords: "sample xlsx, xlsx download, xlsx file example, free xlsx",
        bodyText: (
          <article>
            <p>
              <strong>XLSX</strong> is the modern Excel spreadsheet format
              introduced with Office Open XML in 2007. It offers better
              compression, broad compatibility, and support for advanced
              spreadsheet features.
            </p>
            <p>
              Picture a startup CFO forecasting revenue for the next 5 years —
              using{" "}
              <strong>
                live charts, AI insights, and a million rows of data
              </strong>{" "}
              — all in one file. That’s <strong>.XLSX</strong> — the{" "}
              <strong>modern Excel format</strong> that turns numbers into
              superpowers. Launched in 2007, it’s the brain behind data-driven
              decisions worldwide.
            </p>

            <p>
              An .XLSX file supports{" "}
              <strong>
                Power Query, slicers, 3D maps, forecast sheets, and pivot tables
              </strong>{" "}
              that summarize millions of rows in seconds. It’s XML-based, so{" "}
              <strong>corrupted files can be unzipped and fixed</strong>.
              Teachers use it for gradebooks; scientists use it for research;
              marketers use it for campaign ROI.
            </p>

            <p>
              <strong>How to open .XLSX:</strong>
              1. <strong>Excel</strong> (Windows/Mac). 2.{" "}
              <strong>Google Sheets</strong> (free). 3.{" "}
              <strong>LibreOffice Calc</strong>.
              <strong>File won’t load?</strong> Clear temp files or rename to
              .zip.<br></br>
              <strong>How to create:</strong> Just save — .xlsx is default.
              <br></br>
              <strong>How to edit:</strong> Use “Get & Transform” to clean data
              fast.
            </p>

            <p>
              <strong>Pro tips:</strong>- <strong>Compress large files</strong>{" "}
              — remove unused rows. - <strong>Share safely</strong> — save as
              PDF or CSV. - <strong>Automate</strong> — use Power Query for
              monthly reports. - <strong>Cloud edit</strong> — save to OneDrive.
            </p>

            <p>
              XLSX is <strong>macro-free by default</strong> and{" "}
              <strong>cloud-native</strong> — edit anywhere.
            </p>

            <section>
              <h5>Why XLSX is Data’s Best Friend</h5>
              <ul>
                <li>
                  <strong>Million-Row Power:</strong> Handle big data
                </li>
                <li>
                  <strong>Live Visuals:</strong> Charts update instantly
                </li>
                <li>
                  <strong>AI Insights:</strong> Excel predicts trends
                </li>
                <li>
                  <strong>Automation:</strong> Power Query, VBA
                </li>
                <li>
                  <strong>Recoverable:</strong> Unzip to fix
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .XLSX sample files</strong> to test pivot
              tables, charts, or forecasting. Perfect for analysts, planners,
              and anyone who loves data.
            </p>
          </article>
        ),
      };
    case "odt":
      return {
        title: "Sample odt file - Free odt Files for Testing",
        screenTitle: "Sample odt file",
        description:
          "Free sample ODT (OpenDocument Text) file for testing word processors.",
        keywords: "sample odt, odt file download, odt file example, free odt",
        bodyText: (
          <article>
            <p>
              Imagine a world where you never pay for word processing again.
              That’s <strong>.ODT</strong> — the{" "}
              <strong>open-source document format</strong> used by{" "}
              <strong>LibreOffice</strong> and{" "}
              <strong>Apache OpenOffice</strong>, two free alternatives to
              Microsoft Word. Launched in 2005, ODT is a global standard for
              governments, schools, and anyone who values freedom.
            </p>

            <p>
              An .ODT file supports{" "}
              <strong>
                styles, tables, track changes, mail merge, and even drawing
                tools
              </strong>{" "}
              — everything Word does, but without subscriptions or licensing
              fees. It’s built on <strong>ZIP-compressed XML</strong>, so files
              are small and can be recovered if corrupted. Countries like
              Germany and Brazil mandate ODT for public documents to ensure{" "}
              <strong>long-term access</strong> — no vendor lock-in.
            </p>

            <p>
              <strong>Pro tips:</strong>- <strong>Export to PDF</strong> for
              sharing — universal and print-ready. -{" "}
              <strong>Convert to .docx</strong> if sending to Word users. -{" "}
              <strong>Reduce size</strong> — compress images before saving. -{" "}
              <strong>Use templates</strong> — LibreOffice has thousands free.
            </p>

            <p>
              ODT is <strong>cross-platform</strong> (Windows, Mac, Linux) and{" "}
              <strong>future-proof</strong> — the standard is public, so it will
              never disappear. It’s perfect for{" "}
              <strong>students, NGOs, and open-data projects</strong>.
            </p>

            <section>
              <h5>Why ODT is Freedom in a File</h5>
              <ul>
                <li>
                  <strong>100% Free:</strong> No cost, no subscriptions
                </li>
                <li>
                  <strong>Open Standard:</strong> Anyone can build tools
                </li>
                <li>
                  <strong>Cross-Platform:</strong> Works on any OS
                </li>
                <li>
                  <strong>Light & Fixable:</strong> Unzip to recover text
                </li>
                <li>
                  <strong>Global Standard:</strong> Used by governments
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .ODT sample files</strong> to test
              open-source workflows, government forms, or cost-free editing.
              Ideal for students, activists, and anyone tired of paying for
              software.
            </p>
          </article>
        ),
      };
    case "rtf":
      return {
        title: "Sample rtf file Download - Free Sample Files",
        screenTitle: "Sample rtf download",

        description:
          "Download a free sample RTF document for testing text editors.",
        keywords: "sample rtf, rtf download, rtf file example, free rtf",
        bodyText: (
          <article>
            <p>
              It’s 1995. You need to send a formatted resume to a friend — but
              they use a Mac, you use Windows. The solution?{" "}
              <strong>.RTF</strong> — <strong>Rich Text Format</strong>, created
              by Microsoft in 1987 to be the <strong>universal bridge</strong>{" "}
              between word processors.
            </p>

            <p>
              An .RTF file keeps{" "}
              <strong>
                bold, italics, colors, fonts, tables, and alignment
              </strong>{" "}
              — but opens in <strong>any app</strong> from WordPad to TextEdit
              to Google Docs. It’s <strong>safe (no macros)</strong>, tiny, and{" "}
              <strong>human-readable</strong> in Notepad. Use it for{" "}
              <strong>email attachments, help files, or legacy software</strong>{" "}
              that rejects .docx.
            </p>

            <p>
              <strong>Pro tips:</strong>- <strong>Use for email</strong> —
              avoids formatting shifts in Outlook. -{" "}
              <strong>Keep fonts simple</strong> — Arial, Times, or Courier. -{" "}
              <strong>Convert to PDF</strong> for final sharing. -{" "}
              <strong>Fix size</strong> — RTF can bloat with images; compress
              first.
            </p>

            <p>
              RTF is <strong>lightweight</strong> (a 5-page doc = ~50 KB) and{" "}
              <strong>opens on 35-year-old computers</strong>. It’s the{" "}
              <strong>safest way to share formatted text</strong> without
              compatibility drama.
            </p>

            <section>
              <h5>Why RTF Never Dies</h5>
              <ul>
                <li>
                  <strong>Opens Everywhere:</strong> Since 1987, any OS
                </li>
                <li>
                  <strong>Formatted & Safe:</strong> No virus risk
                </li>
                <li>
                  <strong>Tiny Files:</strong> Perfect for email
                </li>
                <li>
                  <strong>Editable in Any App:</strong> Even on old Macs
                </li>
                <li>
                  <strong>Universal Bridge:</strong> Word ↔ Pages ↔ LibreOffice
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .RTF sample files</strong> for safe,
              formatted sharing — resumes, instructions, or cross-platform
              notes. Great for admins, writers, and anyone who hates “it looks
              wrong on my computer.”
            </p>
          </article>
        ),
      };
    case "txt":
      return {
        title: "Sample text file",
        screenTitle: "Sample text download",

        description:
          "Free sample TXT text file for testing plain text support. Download instantly.",
        keywords: "sample txt, txt download, txt file example, free txt",
        bodyText: (
          <article>
            <p>
              It’s 1971. A programmer types a note on a teletype machine. The
              file? <strong>.TXT</strong> — <strong>plain text</strong>, the{" "}
              <strong>oldest, simplest, most universal format</strong> in
              computing. No fonts, no images, no formatting — just pure words.
              And in 2025, it’s still the{" "}
              <strong>most reliable file on Earth</strong>.
            </p>

            <p>
              A .TXT file opens on <strong>every device ever made</strong> —
              from smart fridges to space probes to 40-year-old computers. Use
              it for{" "}
              <strong>notes, logs, code, configs, passwords, or scripts</strong>
              . A 1,000-page novel in .txt is under 2 MB.{" "}
              <strong>UTF-8 encoding</strong> supports emojis, accents, and all
              languages — no more garbled text.
            </p>

            <p>
              <strong>Pro tips:</strong>- <strong>Always save as UTF-8</strong>{" "}
              — supports 🌍 and ñ. - <strong>Use line breaks</strong> — Windows:
              CRLF, Mac/Linux: LF. - <strong>Backup everything</strong> — .txt
              can’t be corrupted by formatting. - <strong>Email safely</strong>{" "}
              — attach or paste in body.
            </p>

            <p>
              .TXT is <strong>impossible to break</strong> — no viruses, no
              bloat, no obsolescence. It’s the{" "}
              <strong>only file format guaranteed to open in 2100</strong>.
            </p>

            <section>
              <h5>Why TXT is Unstoppable</h5>
              <ul>
                <li>
                  <strong>Works Anywhere:</strong> Every OS, every device
                </li>
                <li>
                  <strong>Zero Size:</strong> 1 page = ~2 KB
                </li>
                <li>
                  <strong>No Corruption:</strong> Pure text, no surprises
                </li>
                <li>
                  <strong>Editable Forever:</strong> Even on a calculator
                </li>
                <li>
                  <strong>Universal Language:</strong> Code, logs, notes
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .TXT sample files</strong> for logs,
              scripts, or plain data. Perfect for developers, writers, and
              anyone who values simplicity and reliability.
            </p>
          </article>
        ),
      };
    case "csv":
      return {
        title: "Sample CSV File - Free CSV Sample Data",
        screenTitle: "Sample CSV download",
        description:
          "Download a sample CSV file for spreadsheet testing, data analysis, and database import. Free CSV sample.",
        keywords:
          "sample csv, csv file download, csv data example, excel csv test file, comma separated values sample",
        bodyText: (
          <article>
            <p>
              <strong>CSV (Comma-Separated Values)</strong> is a simple{" "}
              <strong>data format</strong> used for storing{" "}
              <strong>tabular data</strong> in plain text. Each line in a CSV
              file represents a row, with values separated by commas, making it
              compatible with{" "}
              <strong>
                spreadsheets, databases, and programming languages
              </strong>
              .
            </p>

            <p>
              CSV is widely used for{" "}
              <strong>
                data analysis, machine learning, reporting, and data migration
              </strong>
              . It is supported by applications like{" "}
              <strong>
                Microsoft Excel, Google Sheets, Python, and SQL databases
              </strong>
              , making it a universal choice for structured data exchange.
            </p>

            <p>
              A .CSV file holds{" "}
              <b>
                customer lists, product catalogs, survey results, or financial
                data
              </b>
              . Open it in Excel, Google Sheets, or Notepad — it’s{" "}
              <b>human-readable</b>. Use quotes for commas in text: `"Smith,
              John"`. Save as <b>CSV UTF-8</b> to support accents, emojis, and
              global characters.
            </p>

            <p>
              <strong>Pro tips:</strong>- <b>Check delimiter</b> — Europe often
              uses semicolons. - <b>Avoid extra commas</b> — wrap text in
              quotes. - <b>Backup before import</b> — CSV has no undo. -{" "}
              <b>Use headers</b> — makes imports smarter.
            </p>

            <p>
              .CSV is <b>lightning-fast</b> — 100,000 rows import in seconds.
              It’s the{" "}
              <b>only format every database, CRM, and analytics tool speaks</b>.
            </p>

            <section>
              <h5>Why CSV Moves the World</h5>
              <ul>
                <li>
                  <strong>Every App Speaks It:</strong> Excel, SQL, Python, CRMs
                </li>
                <li>
                  <strong>Fast Imports:</strong> Millions of rows instantly
                </li>
                <li>
                  <strong>Fixable in Text:</strong> Edit manually in Notepad
                </li>
                <li>
                  <strong>No Bloat:</strong> Just data, no formulas
                </li>
                <li>
                  <strong>Universal Export:</strong> From any system
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .CSV sample files</strong> to test imports,
              parsing, or data migration. Perfect for analysts, shop owners, and
              anyone moving data between tools.
            </p>
          </article>
        ),
      };

    case "zip":
      return {
        title: "Sample zip file Download - Free Sample Files",
        screenTitle: "Sample zip download",
        description:
          "Download a free sample ZIP archive file for testing compressed files.",
        keywords:
          "sample zip, zip file download, zip example, free zip archive",
        bodyText: (
          <article>
            <p>
              The <strong>.ZIP</strong> file is the{" "}
              <strong>original archive standard</strong>, created in 1989 — the
              file you emailed with “resume.zip”, downloaded software, or backed
              up homework. It’s the duct tape of file sharing.
            </p>

            <p>
              A .ZIP supports{" "}
              <strong>
                password protection, splitting, and up to 4 GB files
              </strong>{" "}
              — simple and reliable.{" "}
              <strong>Every OS opens ZIP natively</strong>. Default in{" "}
              <strong>email attachments</strong> and{" "}
              <strong>web downloads</strong>.
            </p>
            <p>
              <strong>ZIP</strong> is the universal compression format that
              shrinks files and folders into one portable archive. The go-to for
              backups and sharing.
            </p>

            <p>
              <strong>How to open:</strong> Double-click on{" "}
              <strong>Windows/Mac</strong>, or use <strong>7-Zip</strong>.
              <br></br>
              <strong>Can’t open?</strong> Repair with 7-Zip or redownload.
              <br></br>
              <strong>How to create:</strong> Right-click → Send to → Compressed
              folder.<br></br>
              <strong>Pro tip:</strong> Use AES-256 encryption for sensitive
              data.
            </p>

            <p>
              Simple and universal, .ZIP is <strong>built into every OS</strong>
              . Not the smallest, but perfect for <strong>quick sharing</strong>
              .
            </p>

            <section>
              <h5>Why .ZIP Still Matters</h5>
              <ul>
                <li>
                  <strong>Native Everywhere:</strong> No software needed
                </li>
                <li>
                  <strong>Fast to Create/Open:</strong> Instant archives
                </li>
                <li>
                  <strong>Email-Safe:</strong> Widely allowed
                </li>
                <li>
                  <strong>Password Support:</strong> Basic security
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .ZIP sample files</strong> to test
              extraction, scripting, or backup tools. Perfect for admins,
              students, and everyday users.
            </p>
          </article>
        ),
      };
    case "7z":
      return {
        title: "Sample 7Z File Download - Free 7-Zip Sample Files",
        screenTitle: "Sample 7z download",

        description:
          "Download a sample 7Z compressed archive for testing extraction, compression tools, and file handling. Free 7Z sample.",
        keywords:
          "sample 7z, 7z file download, 7-zip archive example, compressed 7z sample file, test 7z format",
        bodyText: (
          <article>
            <p>
              <strong>7Z (7-Zip Archive)</strong> is a{" "}
              <strong>compressed file format</strong> developed by Igor Pavlov
              for the <strong>7-Zip utility</strong>. Known for its{" "}
              <strong>high compression ratio</strong> and support for large
              files, <strong>7Z files</strong> are widely used for packaging and
              transferring data efficiently.
            </p>

            <p>
              7Z supports advanced compression methods,{" "}
              <strong>AES-256 encryption</strong>, and multi-volume archives,
              making it a reliable choice for{" "}
              <strong>secure data storage and distribution</strong>. Compared to
              ZIP or RAR, 7Z files often achieve smaller sizes without
              sacrificing data integrity.
              <strong>7Z</strong> is the open-source, ultra-high compression
              format from 7-Zip. It beats RAR and ZIP in size, with AES-256
              encryption.
            </p>
            <p>
              A .7Z supports{" "}
              <strong>
                extreme compression, solid archives, and header encryption
              </strong>{" "}
              — smallest possible size.{" "}
              <strong>7-Zip opens it free on all platforms</strong>. Rising in{" "}
              <strong>software distribution</strong>.
            </p>

            <p>
              Brutally efficient, .7Z is <strong>30% smaller than ZIP</strong>.
              Slower, but perfect for <strong>storage and bandwidth</strong>.
            </p>

            <section>
              <h5>Why .7Z Still Matters</h5>
              <ul>
                <li>
                  <strong>Best Compression:</strong> Saves most space
                </li>
                <li>
                  <strong>Open Source:</strong> Free forever
                </li>
                <li>
                  <strong>Strong Encryption:</strong> AES-256
                </li>
                <li>
                  <strong>Header Compression:</strong> Hides filenames
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .7Z sample files</strong> to test
              compression ratios, encryption, or backup scripts. Perfect for
              devs and data hoarders.
            </p>
          </article>
        ),
      };
    case "tar":
      return {
        title: "Sample TAR File - Download TAR Archive Sample",
        screenTitle: "Sample TAR download",
        description:
          "Download a sample TAR archive file for Linux, Unix, and backup testing. Free TAR sample.",
        keywords:
          "sample tar, tar file download, unix tar archive, linux tarball example, tar test file",
        bodyText: (
          <article>
            <p>
              <strong>TAR (Tape Archive)</strong> is a standard{" "}
              <strong>archiving format</strong> commonly used in{" "}
              <strong>Linux and Unix</strong> systems. TAR files (also called{" "}
              <strong>tarballs</strong>) are designed to package multiple files
              into a single archive without applying compression.
            </p>

            <p>
              The <strong>.TAR</strong> file is the{" "}
              <strong>Unix archive classic</strong>, born in 1979 — the format
              in Linux packages, /home backups, and open-source tarballs. It’s
              the “tape archive” that outlived tapes.
            </p>
            <p>
              A .TAR supports{" "}
              <strong>file permissions, symlinks, and long paths</strong> —
              preserves Unix metadata.{" "}
              <strong>Every Linux/Mac terminal opens tar natively</strong>.
              Foundation of <strong>.deb, .rpm, and Docker</strong>.
            </p>
            <section>
              <h5>Why .TAR Still Matters</h5>
              <ul>
                <li>
                  <strong>Preserves Permissions:</strong> Critical for Unix
                </li>
                <li>
                  <strong>Scriptable:</strong> Backup/restore automation
                </li>
                <li>
                  <strong>Base for .tgz, .tbz:</strong> Gzip, bzip2
                </li>
                <li>
                  <strong>Streaming:</strong> Pipe without temp files
                </li>
              </ul>
            </section>
            <p>
              <strong>Download free .TAR sample files</strong> to test backups,
              Docker layers, or Linux scripting. Perfect for sysadmins and
              developers.
            </p>
          </article>
        ),
      };
    case "rar":
      return {
        title: "Sample RAR File - Free RAR Sample Archives",
        screenTitle: "Sample RAR download",
        description:
          "Download a sample RAR archive file for testing extraction and compression. Free RAR sample.",
        keywords:
          "sample rar, rar file download, rar archive example, winrar sample file, test rar compression",
        bodyText: (
          <article>
            <p>
              <strong>RAR (Roshal Archive)</strong> is a popular{" "}
              <strong>compressed file format</strong> created by Eugene Roshal
              and commonly used with <strong>WinRAR</strong>. Known for{" "}
              <strong>strong compression</strong> and advanced features like{" "}
              <strong>error recovery</strong> and{" "}
              <strong>password protection</strong>, RAR files are widely used
              for packaging large datasets, software, and media files.
            </p>

            <p>
              Unlike standard ZIP files, <strong>RAR archives</strong> often
              provide better compression ratios, making them ideal for efficient
              file sharing. They also support{" "}
              <strong>multi-part splitting</strong>, which helps in distributing
              large files across multiple volumes.
            </p>

            <p>
              <strong>RAR</strong> is the high-compression archive format with
              advanced features like recovery records and splitting. The choice
              for large file transfers.
            </p>

            <p>
              <strong>How to open:</strong> Use <strong>WinRAR</strong> or{" "}
              <strong>7-Zip</strong>.<strong>Can’t open?</strong> Use recovery
              record or repair.<br></br>
              <strong>How to create:</strong> WinRAR → Add to archive → RAR.
              <br></br>
              <strong>Pro tip:</strong> Add 5% recovery record for flaky
              downloads.
            </p>

            <section>
              <h5>Why .RAR Still Matters</h5>
              <ul>
                <li>
                  <strong>Better Compression:</strong> Smaller archives
                </li>
                <li>
                  <strong>Repair Built-In:</strong> Fixes corrupt parts
                </li>
                <li>
                  <strong>Split Volumes:</strong> Fits on old media
                </li>
                <li>
                  <strong>Encryption:</strong> Stronger than ZIP
                </li>
              </ul>
            </section>

            <p>
              <strong>Download free .RAR sample files</strong> to test recovery,
              splitting, or large archives. Perfect for sysadmins and file
              hoarders.
            </p>
          </article>
        ),
      };

    case "json":
      return {
        title: "Sample JSON File - Free JSON Sample Data",
        screenTitle: "Sample JSON download",
        description:
          "Download a sample JSON file for API testing, software development, and structured data analysis. Free JSON sample.",
        keywords:
          "sample json, json file download, json data example, api json test file, structured json format",
        bodyText: (
          <article>
            <p>
              <strong>JSON (JavaScript Object Notation)</strong> is a
              lightweight <strong>data format</strong> used to represent
              structured information in a simple, text-based form. It has become
              the most popular choice for{" "}
              <strong>
                APIs, web applications, and modern software development
              </strong>
              .
            </p>

            <p>
              JSON is easy to read and write, with a{" "}
              <strong>key-value pair structure</strong> that makes it ideal for{" "}
              <strong>
                configuration files, API requests/responses, and database
                storage
              </strong>
              . It is supported across virtually all programming languages,
              making it highly versatile.
            </p>

            <p>
              A .json file stores{" "}
              <b>key-value pairs, arrays, and nested objects</b> — think of it
              as a digital dictionary. It’s <b>human-readable</b> and{" "}
              <b>lightweight</b>: a list of 100 users might be just 5 KB.
              Facebook, Google, and your weather app all use JSON behind the
              scenes. It’s the <b>backbone of REST APIs</b>, config files, and
              NoSQL databases like MongoDB.
            </p>

            <p>
              JSON is <b>strict but simple</b> — one typo breaks everything. But
              it’s <b>faster than XML</b> and <b>native to JavaScript</b>. It’s
              the <b>only format every web language understands</b>.
            </p>

            <h5>Why JSON Rules the Web</h5>
            <ul>
              <li>
                <strong>Human + Machine Readable:</strong> Clean and logical
              </li>
              <li>
                <strong>Lightweight:</strong> 70% smaller than XML
              </li>
              <li>
                <strong>Universal:</strong> Used by Python, Java, PHP, etc.
              </li>
              <li>
                <strong>API Standard:</strong> Powers OpenAI, Stripe, Twitter
              </li>
              <li>
                <strong>Nestable:</strong> Complex data in one file
              </li>
            </ul>

            <p>
              <strong>Download Free .json Sample Files</strong>
              Test APIs, config setups, or data parsing. Perfect for web devs
              and app builders.
            </p>
          </article>
        ),
      };
    case "xml":
      return {
        title: "Sample XML File - Free XML Sample Files",
        screenTitle: "Sample XML download",
        description:
          "Download a sample XML file for testing structured data, parsing, and software integration. Free XML sample.",
        keywords:
          "sample xml, xml file download, xml data example, structured data xml, test xml format",
        bodyText: (
          <article>
            <p>
              <strong>XML (Extensible Markup Language)</strong> is a widely used{" "}
              <strong>data format</strong> for representing structured
              information. It uses <strong>tag-based syntax</strong> to describe
              data in a way that is both{" "}
              <strong>human-readable and machine-readable</strong>.
            </p>
            <p>
              XML is commonly applied in{" "}
              <strong>
                web services, configuration files, document storage, and data
                exchange
              </strong>{" "}
              between applications. Its flexibility makes it a cornerstone in
              industries like finance, healthcare, and enterprise software
              systems.
            </p>

            <p>
              An .xml file wraps data in <b>opening and closing tags</b>:{" "}
              <code>
                &lt;book&gt;&lt;title&gt;1984&lt;/title&gt;&lt;/book&gt;
              </code>
              . It’s <b>verbose but flexible</b> — used in{" "}
              <b>
                Android apps, SVG graphics, Office files (.docx), and RSS feeds
              </b>
              . Governments and banks love XML for <b>strict validation</b> via
              XSD schemas.
            </p>

            <p>
              XML is <b>heavier than JSON</b> but <b>self-documenting</b> — you
              see structure at a glance. It’s the{" "}
              <b>gold standard for enterprise data</b>.
            </p>

            <h5>Why XML Still Matters</h5>
            <ul>
              <li>
                <strong>Self-Describing:</strong> Tags explain data
              </li>
              <li>
                <strong>Strict Validation:</strong> XSD ensures correctness
              </li>
              <li>
                <strong>Enterprise Ready:</strong> Used in SOAP, banking
              </li>
              <li>
                <strong>Cross-Platform:</strong> Any language parses it
              </li>
              <li>
                <strong>Backward Compatible:</strong> 25+ years strong
              </li>
            </ul>

            <p>
              <strong>Download Free .xml Sample Files</strong>
              Test parsing, validation, or Android layouts. Great for backend
              devs.
            </p>
          </article>
        ),
      };
    case "html":
      return {
        title: "Sample HTML File  - Free HTML Example Code",
        screenTitle: "Sample HTML download",
        description:
          "Download a sample HTML file for web development practice and browser testing. Free HTML sample.",
        keywords:
          "sample html, html file download, html example code, web development sample, test html file",
        bodyText: (
          <article>
            <p>
              It’s 1991. Tim Berners-Lee invents the <b>web page</b>. The file?{" "}
              <strong>HTML</strong> — <b>HyperText Markup Language</b>, the{" "}
              <b>skeleton of every website</b>. Without HTML, no Google, no
              YouTube, no internet.
            </p>
            <p>
              <strong>HTML (HyperText Markup Language)</strong> is the core{" "}
              <strong>markup language</strong> for creating and structuring web
              pages. Every website relies on HTML to define headings,
              paragraphs, links, images, and other page elements.
            </p>

            <p>
              HTML files are essential for{" "}
              <strong>web developers, students, and testers</strong> learning
              how to build websites. Combined with CSS and JavaScript, it powers
              modern web experiences across all devices and browsers.
            </p>

            <p>
              An .html file uses <b>tags</b>: <code>&lt;p&gt;</code>,{" "}
              <code>&lt;img&gt;</code>, <code>&lt;a&gt;</code>. It tells
              browsers <b>what</b> to show — CSS styles it, JavaScript makes it
              move. Every site starts with <code>&lt;!DOCTYPE html&gt;</code>.
            </p>

            <p>
              HTML is <b>simple but essential</b> — the{" "}
              <b>first step to web mastery</b>.
            </p>

            <h5>Why HTML is Forever</h5>
            <ul>
              <li>
                <strong>Universal:</strong> Every device renders it
              </li>
              <li>
                <strong>Semantic:</strong> SEO + accessibility
              </li>
              <li>
                <strong>Progressive:</strong> HTML5 video, canvas
              </li>
              <li>
                <strong>Free:</strong> No software needed
              </li>
              <li>
                <strong>Gateway:</strong> To CSS, JS, frameworks
              </li>
            </ul>

            <p>
              <strong>Download Free .html Sample Files</strong>
              Test layouts, forms, or responsive design.
            </p>
          </article>
        ),
      };
    case "bat":
      return {
        title: "Sample BAT File Download - Free Windows Batch Script",
        screenTitle: "Sample BAT download",
        description:
          "Download a sample BAT batch file for Windows scripting and automation testing. Free BAT sample.",
        keywords:
          "sample bat, bat file download, windows batch script example, command line bat file, test bat automation",
        bodyText: (
          <article>
            <p>
              It’s 1985. You’re in MS-DOS, typing commands to copy files. The
              script? A <strong>.BAT</strong> file — <b>batch file</b>, the{" "}
              <b>original Windows automation tool</b>. Even in 2025, IT admins
              use .bat to restart servers, backup data, and deploy software.
            </p>
            <p>
              <strong>BAT (Batch File)</strong> is a{" "}
              <strong>script file</strong> for Windows operating systems,
              containing a series of commands executed by the{" "}
              <strong>Command Prompt (CMD)</strong>. BAT files are commonly used
              for{" "}
              <strong>
                automation, task scheduling, and system configuration
              </strong>
              .
            </p>

            <p>
              Developers and IT administrators rely on BAT files to streamline
              processes such as{" "}
              <strong>
                file backups, software installations, and command execution
              </strong>
              . They provide a fast and efficient way to handle repetitive
              tasks.
            </p>

            <p>
              A .bat file is <b>plain text with DOS commands</b>:{" "}
              <code>copy</code>, <code>del</code>, <code>echo</code>,{" "}
              <code>if</code>. One click runs 100 tasks. Use it to{" "}
              <b>automate updates, clean temp files, or launch apps</b>.
              Double-click — and magic happens.
            </p>

            <p>
              .BAT is <b>fast, lightweight, and built into Windows</b> — no
              install needed. It’s the <b>quiet hero of system admin</b>.
            </p>

            <h5>Why .BAT Still Rules Windows</h5>
            <ul>
              <li>
                <strong>Native to Windows:</strong> No software needed
              </li>
              <li>
                <strong>One-Click Automation:</strong> Backup, cleanup, deploy
              </li>
              <li>
                <strong>Lightweight:</strong> 1 KB runs 100 tasks
              </li>
              <li>
                <strong>Admin Favorite:</strong> Used in enterprise
              </li>
              <li>
                <strong>Legacy Power:</strong> Works on Windows 95+
              </li>
            </ul>

            <p>
              <strong>Download Free .bat Sample Files</strong>
              Test backups, cleanup scripts, or automation. Perfect for IT pros.
            </p>
          </article>
        ),
      };
    case "c":
      return {
        title: "Sample C File  - Free C Program Example",
        screenTitle: "Sample C download",
        description:
          "Download a sample C file with source code for learning programming and compiler testing. Free C sample.",
        keywords:
          "sample c, c file download, c program example, c source code sample, test c language",
        bodyText: (
          <article>
            <p>
              <strong>C Language</strong> is a powerful, general-purpose{" "}
              <strong>programming language</strong> developed in the early 1970s
              by Dennis Ritchie. It is widely used for{" "}
              <strong>
                system programming, embedded systems, and operating systems
              </strong>
              .
            </p>

            <p>
              C source code files use the <strong>.c extension</strong> and are
              compiled into machine code for execution. Its simplicity,
              efficiency, and portability have made C a foundation for many
              modern programming languages.
            </p>

            <p>
              C gives <b>total control</b> — but one mistake crashes everything.
              It’s the <b>training ground for real programmers</b>.
            </p>

            <h5>Why C is Eternal</h5>
            <ul>
              <li>
                <strong>Speed:</strong> Closest to machine code
              </li>
              <li>
                <strong>Portable:</strong> Runs on any CPU
              </li>
              <li>
                <strong>Embedded:</strong> IoT, cars, rockets
              </li>
              <li>
                <strong>Foundation:</strong> C++, Java, Python built on it
              </li>
              <li>
                <strong>50+ Years:</strong> Still in kernels
              </li>
            </ul>

            <p>
              <strong>Download Free .c Sample Files</strong>
              Test algorithms, system tools, or embedded logic. Perfect for
              students.
            </p>
          </article>
        ),
      };
    case "cpp":
      return {
        title: "Sample C++ File Download - Free C++ Program Example",
        screenTitle: "Sample C++ download",
        description:
          "Download a sample C++ source code file for OOP learning, compiler testing, and coding practice. Free C++ sample.",
        keywords:
          "sample cpp, c++ file download, c++ program example, cpp source code sample, test c++ code",
        bodyText: (
          <article>
            <p>
              It’s 1985. Bjarne Stroustrup adds <b>objects</b> to C. The result?{" "}
              <strong>C++</strong> — <b>C with classes</b>, now the{" "}
              <b>king of high-performance software</b>. Games, browsers, and
              trading systems run on C++.
            </p>
            <p>
              <strong>C++</strong> is a versatile{" "}
              <strong>programming language</strong> developed by Bjarne
              Stroustrup as an extension of C. It supports{" "}
              <strong>object-oriented programming (OOP)</strong>, making it
              suitable for{" "}
              <strong>
                software development, game engines, and system-level
                applications
              </strong>
              .
            </p>

            <p>
              C++ source code files typically use the{" "}
              <strong>.cpp extension</strong> and allow developers to work with
              classes, inheritance, and polymorphism. Its speed and flexibility
              have made it a favorite for high-performance applications.
            </p>

            <p>
              C++ is <b>complex but unbeatable</b> for <b>speed and control</b>.
            </p>

            <h5>Why C++ Dominates Performance</h5>
            <ul>
              <li>
                <strong>Zero-Cost Abstractions:</strong> Fast + safe
              </li>
              <li>
                <strong>Game Engines:</strong> Unreal, Unity (C# wrapper)
              </li>
              <li>
                <strong>AAA Games:</strong> GTA, Call of Duty
              </li>
              <li>
                <strong>Real-Time:</strong> Trading, simulations
              </li>
              <li>
                <strong>Modern C++:</strong> Cleaner than ever
              </li>
            </ul>

            <p>
              <strong>Download Free .cpp Sample Files</strong>
              Test games, algorithms, or graphics.
            </p>
          </article>
        ),
      };
    case "py":
      return {
        title: "Sample Python File  - Free Python Script Example",
        screenTitle: "Sample Python download",
        description:
          "Download a sample Python script file for coding practice, automation, and software testing. Free Python sample.",
        keywords:
          "sample python, python file download, python script example, py file sample, test python code",
        bodyText: (
          <article>
            <p>
              <strong>Python</strong> is a high-level{" "}
              <strong>programming language</strong> known for its readability
              and versatility. Created by Guido van Rossum, it is widely used
              for{" "}
              <strong>
                web development, automation, data science, AI, and scripting
              </strong>
              .
            </p>

            <p>
              Python files use the <strong>.py extension</strong> and can run on
              multiple platforms with ease. Its simplicity makes it a top choice
              for both beginners and experienced developers.
            </p>
            <p>
              It’s 1991. Guido van Rossum wants a{" "}
              <b>simple, readable language</b>. The result?{" "}
              <strong>Python</strong> — now the <b>#1 language</b> for AI, web,
              and automation. NASA, Netflix, and Instagram run on Python.
            </p>

            <h5>Why Python Wins</h5>
            <ul>
              <li>
                <strong>Readable:</strong> Like English
              </li>
              <li>
                <strong>AI/ML:</strong> Pandas, Scikit-learn
              </li>
              <li>
                <strong>Web:</strong> Django, Flask
              </li>
              <li>
                <strong>Automation:</strong> Scripts in minutes
              </li>
              <li>
                <strong>Community:</strong> 10M+ devs
              </li>
            </ul>

            <p>
              <strong>Download Free .py Sample Files</strong>
              Test automation, data, or web apps.
            </p>
          </article>
        ),
      };
    case "rb":
      return {
        title: "Sample Ruby File  - Free Ruby Script Example",
        screenTitle: "Sample Ruby download",
        description:
          "Download a sample Ruby script file for coding practice and software testing. Free Ruby sample.",
        keywords:
          "sample ruby, ruby file download, ruby script example, rb file sample, test ruby code",
        bodyText: (
          <article>
            <p>
              <strong>Ruby</strong> is a dynamic, object-oriented{" "}
              <strong>programming language</strong> designed for simplicity and
              productivity. Created by Yukihiro Matsumoto, Ruby emphasizes
              human-friendly syntax and is widely used in{" "}
              <strong>web development</strong>, especially with the{" "}
              <strong>Ruby on Rails framework</strong>.
            </p>

            <p>
              Ruby files typically use the <strong>.rb extension</strong> and
              are great for <strong>automation, web apps, and scripting</strong>
              . Its elegant syntax makes it easy for beginners while offering
              powerful features for experts.
            </p>
            <p>
              It’s 1995. Yukihiro Matsumoto wants coding to be <b>fun</b>. He
              creates <strong>Ruby</strong> — <b>elegant, human-first syntax</b>
              . Ruby on Rails launched Twitter, GitHub, and Shopify.
            </p>

            <h5>Why Ruby Sparks Joy</h5>
            <ul>
              <li>
                <strong>Elegant:</strong> Code like poetry
              </li>
              <li>
                <strong>Rails:</strong> Web app in hours
              </li>
              <li>
                <strong>Prototyping:</strong> Fast MV10
              </li>
              <li>
                <strong>Community:</strong> Friendly devs
              </li>
            </ul>

            <p>
              <strong>Download Free .rb Sample Files</strong>
              Test Rails, scripts, or automation.
            </p>
          </article>
        ),
      };
    case "js":
      return {
        title: "Sample JavaScript File Download - Free JS Script Example",
        screenTitle: "Sample JavaScript download",
        description:
          "Download a sample JavaScript file for web development, testing, and learning. Free JS sample.",
        keywords:
          "sample javascript, js file download, javascript example code, script sample file, test js file",
        bodyText: (
          <article>
            <article>
              <p>
                It’s 1995. A browser needs to make a webpage <b>interactive</b>{" "}
                — show a popup, validate a form. The answer?{" "}
                <strong>JavaScript</strong> (originally “Mocha”), the{" "}
                <b>only language every browser runs</b>. Today, it powers{" "}
                <b>99.99% of websites</b>.
              </p>

              <p>
                <strong>JavaScript</strong> is the most widely used{" "}
                <strong>programming language</strong> for building interactive
                websites and web applications. It runs directly in the browser,
                making it essential for <strong>frontend development</strong>{" "}
                and increasingly popular in <strong>backend development</strong>{" "}
                with Node.js.
              </p>

              <p>
                JavaScript files use the <strong>.js extension</strong> and
                control dynamic behavior such as animations, form validation,
                and API interactions. It is the backbone of modern web
                development.
              </p>

              <p>
                A .js file contains <b>code that runs in your browser</b>:
                animations, form checks, live search, games.{" "}
                <b>React, Vue, Node.js</b> — all built on JavaScript. It’s{" "}
                <b>event-driven</b>: click a button → run code. A single line
                can fetch data from an API in milliseconds.
              </p>

              <p>
                JavaScript is <b>forgiving but powerful</b> — one typo breaks
                everything. It’s the <b>only way to make websites alive</b>.
              </p>

              <h5>Why JavaScript Runs the Web</h5>
              <ul>
                <li>
                  <strong>Interactive:</strong> Buttons, forms, animations
                </li>
                <li>
                  <strong>Full-Stack:</strong> Frontend + backend (Node.js)
                </li>
                <li>
                  <strong>Real-Time:</strong> Live chat, stock tickers
                </li>
                <li>
                  <strong>Framework Heaven:</strong> React, Angular, Svelte
                </li>
                <li>
                  <strong>Everywhere:</strong> Browsers, servers, apps
                </li>
              </ul>

              <p>
                <strong>Download Free .js Sample Files</strong>
                Test animations, APIs, or games. Perfect for beginners and pros.
              </p>
            </article>
          </article>
        ),
      };
    case "yaml":
      return {
        title: "Sample YAML File Download - Free YAML Example",
        screenTitle: "Sample YAML download",
        description:
          "Download a sample YAML configuration file for testing and software development. Free YAML sample.",
        keywords:
          "sample yaml, yaml file download, yaml config example, yml sample file, test yaml format",
        bodyText: (
          <article>
            <p>
              <strong>YAML (YAML Ain’t Markup Language)</strong> is a{" "}
              <strong>human-readable data format</strong> often used for{" "}
              <strong>
                configuration files, DevOps tools, and cloud deployments
              </strong>
              . Its simple structure makes it easy to write and understand
              compared to XML or JSON.
            </p>

            <p>
              YAML files, with extensions <strong>.yaml</strong> or{" "}
              <strong>.yml</strong>, are widely used in{" "}
              <strong>
                Kubernetes, Docker, CI/CD pipelines, and application settings
              </strong>
              . Its indentation-based structure ensures clean and readable data
              representation.
            </p>
            <p>
              It’s 2001. Developers hate XML config files. The fix?{" "}
              <strong>YAML</strong> — <b>YAML Ain’t Markup Language</b>, the{" "}
              <b>clean, readable config format</b>. Docker, GitHub Actions, and
              Kubernetes run on YAML.
            </p>

            <p>
              A .yml file uses <b>indentation</b> (not braces):{" "}
              <code>name: Alex</code>. No quotes needed. Perfect for{" "}
              <b>config, CI/CD, APIs</b>.
            </p>

            <h5>Why YAML is Config King</h5>
            <ul>
              <li>
                <strong>Readable:</strong> No braces or quotes
              </li>
              <li>
                <strong>DevOps Standard:</strong> Docker, K8s
              </li>
              <li>
                <strong>Flexible:</strong> Lists, maps, anchors
              </li>
              <li>
                <strong>Safe:</strong> No code execution
              </li>
            </ul>

            <p>
              <strong>Download Free .yml Sample Files</strong>
              Test Docker, GitHub Actions, or configs.
            </p>
          </article>
        ),
      };
    case "php":
      return {
        title: "Sample PHP File Download - Free PHP Script Example",
        screenTitle: "Sample PHP download",
        description:
          "Download a sample PHP file for web development, server-side scripting, and testing. Free PHP sample.",
        keywords:
          "sample php, php file download, php script example, php source code sample, test php file",
        bodyText: (
          <article>
            <p>
              <strong>PHP (Hypertext Preprocessor)</strong> is a server-side{" "}
              <strong>scripting language</strong> widely used for{" "}
              <strong>web development</strong>. It powers millions of websites,
              including popular CMS platforms like{" "}
              <strong>WordPress, Joomla, and Drupal</strong>. It’s 1995. A
              developer wants to make a <b>dynamic website</b>. He creates{" "}
              <strong>PHP</strong> — <b>Personal Home Page</b>, now{" "}
              <b>PHP: Hypertext Preprocessor</b>. Today, <b>79% of websites</b>{" "}
              (WordPress, Facebook) run on PHP.
            </p>

            <p>
              PHP files use the <strong>.php extension</strong> and can generate
              dynamic web content, connect to databases, and handle server
              logic. Its flexibility makes it one of the most widely adopted
              programming languages on the web.
            </p>

            <p>
              A .php file mixes <b>HTML and server-side code</b>:{" "}
              <code>&lt;?php echo "Hello"; ?&gt;</code>. It runs on the{" "}
              <b>server</b>, generates HTML, connects to databases. Perfect for{" "}
              <b>blogs, e-commerce, CMS</b>.
            </p>

            <p>
              <strong>How to open:</strong> Use <strong>VS Code</strong> +{" "}
              <strong>XAMPP</strong>.<strong>How to create:</strong> Save as{" "}
              <code>.php</code> → Run on localhost.
              <strong>Pro tip:</strong> Use <b>Laravel</b> for modern apps.
            </p>

            <h5>Why PHP Powers the Web</h5>
            <ul>
              <li>
                <strong>WordPress:</strong> 43% of all sites
              </li>
              <li>
                <strong>Easy Database:</strong> MySQL integration
              </li>
              <li>
                <strong>Fast Development:</strong> Laravel, Symfony
              </li>
              <li>
                <strong>Cheap Hosting:</strong> Shared servers
              </li>
            </ul>

            <p>
              <strong>Download Free .php Sample Files</strong>
              Test forms, login systems, or WordPress plugins.
            </p>
          </article>
        ),
      };
    case "java":
      return {
        title: "Sample Java File Download - Free Java Program Example",
        screenTitle: "Sample Java download",
        description:
          "Download a sample Java source code file for learning, compiler testing, and coding practice. Free Java sample.",
        keywords:
          "sample java, java file download, java program example, java source code sample, test java file",
        bodyText: (
          <article>
            <p>
              It’s 1995. Sun Microsystems wants a language that runs{" "}
              <b>anywhere</b>. The result? <strong>Java</strong> —{" "}
              <b>write once, run anywhere</b>. Today, it powers{" "}
              <b>Android apps, bank systems, and Minecraft</b>.
              <strong> Java</strong> is a powerful, object-oriented{" "}
              <strong>programming language</strong> developed by Sun
              Microsystems in the mid-1990s (now owned by Oracle). It is
              designed with the principle of{" "}
              <strong>“write once, run anywhere”</strong>, thanks to its
              platform-independent <strong>Java Virtual Machine (JVM)</strong>.
            </p>

            <p>
              Java files use the <strong>.java extension</strong> and are
              compiled into bytecode, which can run on any system with a JVM. It
              is widely used in{" "}
              <strong>
                enterprise applications, Android development, web applications,
                and backend services
              </strong>
              .
            </p>

            <p>
              A .java file contains <b>compiled bytecode</b> (`.class`) that
              runs on the <b>JVM</b> (Java Virtual Machine). It’s{" "}
              <b>strongly typed</b> — you declare <code>int age = 25;</code>.
              Used in{" "}
              <b>
                enterprise software, big data (Hadoop), and trading platforms
              </b>
              .
            </p>

            <p>
              Java is <b>verbose but stable</b> — perfect for{" "}
              <b>mission-critical systems</b>.
            </p>

            <h5>Why Java Still Dominates</h5>
            <ul>
              <li>
                <strong>Platform Independent:</strong> JVM handles OS
              </li>
              <li>
                <strong>Enterprise Ready:</strong> Spring, Hibernate
              </li>
              <li>
                <strong>Android Native:</strong> 3B+ devices
              </li>
              <li>
                <strong>Secure:</strong> Sandboxed execution
              </li>
              <li>
                <strong>30 Years Strong:</strong> Backward compatible
              </li>
            </ul>

            <p>
              <strong>Download Free .java Sample Files</strong>
              Test Android logic, algorithms, or backend services.
            </p>
          </article>
        ),
      };

    case "converter":
      return {
        title: "Free JPG to PNG Converter - Convert Image Files Online",
        description:
          "Instantly convert your JPG images to PNG format online for free. Preserve transparency and get lossless quality for web and design projects.",
        keywords:
          "jpg to png, convert jpg to png, image converter, online file converter, jpg png conversion, free image tool",
      };
    case "placeholder-image-generator":
      return {
        title:
          "Free Placeholder Image Generator - Custom Dummy Images for Mockups",
        description:
          "Generate free placeholder images in any size or color. Create custom dummy images for website mockups, design layouts, and testing.",
        keywords:
          "placeholder image, dummy image, image generator, mockup image, test image, design placeholder",
      };
    case "json-generator":
      return {
        title:
          "Advanced mock JSON Generator - Create Custom JSON Data for Testing | SampleFiles.dev",
        description:
          "Generate custom JSON data for testing and development. Create realistic mock APIs, test data with our advanced JSON generator. Free online tool for developers.",
        keywords:
          "placeholder image, dummy image, image generator, mockup image, test image, design placeholder",
      };

    //Blogs pages

    case "blogs":
      return {
        title: "Developer Blogs & Tutorials - SampleFiles.dev",
        description:
          "Explore our collection of articles, guides, and tutorials on file formats, conversion tools, software testing, and web development best practices.",
        keywords:
          "developer blogs, programming tutorials, file format guides, software testing tips, web development blog, tech articles",
        bodyText: `<p>Welcome to the <strong>SampleFiles.dev Blog</strong>, your resource for insightful articles and practical guides for <strong>developers, testers, and designers</strong>. Our content is designed to help you navigate the complexities of file formats, optimize your workflow, and implement best practices in your projects.</p>

<p>Explore in-depth tutorials on topics like <strong>image conversion, file compression, and security</strong>, alongside comparisons of different technologies and formats. Whether you're looking to solve a specific problem or deepen your understanding, our blogs provide the actionable knowledge you need.</p>

<p>Browse our latest posts to stay updated on <strong>industry trends, tool recommendations, and expert tips</strong> for working with sample files and beyond.</p>`,
      };
    case "convert-jpg-to-png-meta-data":
      return {
        title: "Convert JPG to PNG — 3 Quick and Easy Methods",
        description:
          "Learn how to convert JPG to PNG correctly. Our guide covers online tools, software, and best practices for preserving image quality and transparency.",
        keywords:
          "how to convert jpg to png, jpg png tutorial, image conversion guide, preserve transparency, change image format",
      };
    case "sample-file-testing-meta-data":
      return {
        title: "How to Use Sample Files in Software Testing",
        description:
          "Learn best practices for using sample files to test your applications, from checking upload features to validating formats and stress-testing systems.",
        keywords:
          "use sample files, software testing, test files, developer testing, file upload test, qa testing with files",
      };
    case "png-vs-webp-meta-data":
      return {
        title: "PNG vs WebP vs 9-Patch: Which Image Format Wins?",
        description:
          "Compare PNG, WebP, and 9-Patch image formats. Understand the differences in quality, file size, transparency, and use cases for web and mobile development.",
        keywords:
          "png vs webp, nine patch images, image format comparison, webp transparency, android 9-patch, image quality comparison",
      };
    case "image-optimization-meta-data":
      return {
        title:
          "Image Optimization Best Practices - Boost Web Performance Guide",
        description:
          "Master image optimization for faster websites. Learn best practices for compression, format selection, and responsive images to improve page speed and SEO.",
        keywords:
          "image optimization, web performance, page speed, image compression, best practices, core web vitals, seo images",
      };
    case "file-upload-security-meta-data":
      return {
        title: "File Upload Security Best Practices for Developers",
        description:
          "Secure your application's file upload feature. A comprehensive guide to preventing common vulnerabilities, validating files, and protecting against malicious uploads.",
        keywords:
          "file upload security, secure file upload, developer security, web application security, prevent malicious uploads, file validation",
      };
    case "png-paradox-meta-data":
      return {
        title:
          "The PNG Paradox - Fix Transparency, File Size & Quality Mistakes",
        description:
          "Solve the PNG paradox. Learn how to fix common issues with transparency, reduce bloated file sizes, and maintain optimal image quality for the web.",
        keywords:
          "png paradox, png transparency, reduce png file size, png optimization, png quality, fix png issues",
      };
    case "avif-next-gen-meta-data":
      return {
        title:
          "Master AVIF Image Format: The Future of Web Performance | SampleFiles.dev",
        description:
          "Discover how AVIF image format is transforming web performance with superior compression, faster loading, and better quality compared to JPEG, PNG & WebP.",
        keywords:
          "AVIF format, image compression, web performance, next-gen images, AVIF vs WebP, faster loading, image optimization",
      };
    case "3-file-type-meta-data":
      return {
        title: "3 File Types Hackers Use to Spread Malware | SampleFiles.dev",
        description:
          "Learn which 3 dangerous file types pose the biggest security risks when opened from unknown sources. Essential cybersecurity tips for safe file handling.",
        keywords:
          "dangerous file types, cybersecurity, file security, malware protection, safe file handling, virus prevention, security risks",
      };
    case "pdf-docx-meta-data":
      return {
        title:
          "PDF vs DOCX: Which Document Format Is Better? | SampleFiles.dev",
        description:
          "Complete comparison of PDF vs DOCX formats. Learn the differences, advantages, and when to use each file type for documents, sharing, and editing.",
        keywords:
          "PDF vs DOCX, document formats, file comparison, when to use PDF, when to use DOCX, document sharing, editing formats",
      };
    case "json-meta-data":
      return {
        title: "JSON Explained: The Developer's Favorite Data Format",
        description:
          "Understand why JSON is the developer's favorite data format. Learn its simplicity, advantages over XML, and why APIs and web services prefer JSON for data exchange.",
        keywords:
          "json, json tutorial, what is json, javascript object notation, json data format, json example, learn json, json basics",
      };
    case "pdf-editing-meta-data":
      return {
        title: "Master PDF Editing: Best Tools, Tips, and Tricks",
        description:
          "Master PDF editing with the best tools and techniques. Learn how to edit, merge, split, and secure PDFs. Discover free and paid editors for every need.",
        keywords: "Pdf, pdf editing, pdf tip, why pdf used",
      };
    case "png-meta-data":
      return {
        title: "PNG Optimization Guide for Faster Websites",
        description:
          "PNG optimization guide for faster websites. Learn compression techniques, quality settings, and best practices to speed up your site while maintaining PNG quality.",
        keywords: "png, png basic, png performance, png optimization",
      };
    case "jpg-meta-data":
      return {
        title: "When to Use JPG: Pros, Cons, and Use Cases",
        description:
          "Master when to use JPG format. Discover pros, cons, compression techniques, and perfect use cases for photography, web performance, and digital images.",
        keywords: "jpg, jpg basic, jpg performance, jpg optimization",
      };
    case "webp-meta-data":
      return {
        title: "Learn WebP Format: Save Bandwidth and Boost Speed",
        description:
          "Learn how WebP format saves bandwidth and boosts page speed. Discover modern compression technology, implementation tips, and fallback strategies.",
        keywords: "webp, webp basic, webp performance, webp optimization",
      };
    case "gif-meta-data":
      return {
        title: "GIF Format: Still Popular or Time for an Upgrade?",
        description:
          "Explore GIF format: why it's still popular, limitations, and when to upgrade to MP4 or WebP. Learn optimization and modern animation alternatives.",
        keywords: "webp, webp basic, webp performance, webp optimization",
      };
    case "3gp-meta-data":
      return {
        title: "3GP File Format: Legacy, Uses, and Conversions",
        description:
          "Explore 3GP file format: history, benefits, and conversion guide. Learn why it shaped mobile communication and how to use it in today's digital world.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "mp4-meta-data":
      return {
        title: "MP4 Format Explained: Codecs, Quality, and Streaming",
        description:
          "Learn why MP4 dominates video. Understand flexible codecs, streaming capabilities, universal compatibility, and best practices for modern video.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "avi-meta-data":
      return {
        title: "Discover AVI Format: The Classic PC Video Workhorse",
        description:
          "Discover AVI format as the classic PC video workhorse. Explore its legacy, codec limitations, modern compatibility issues, and conversion solutions.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "mkv-meta-data":
      return {
        title: "MKV Format: Why Video Enthusiasts Love It",
        description:
          "Learn why video enthusiasts love MKV format. Discover its flexibility, subtitles support, open-source advantages, and how to create MKV files.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "mov-meta-data":
      return {
        title: "Master MOV Format: Apple's Professional Video Container",
        description:
          "Master MOV format: Apple's professional video container. Learn ProRes codec advantages, editing flexibility, and high-quality video workflows.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "wmv-meta-data":
      return {
        title: "WMV Format: Legacy, Compatibility, and Conversion",
        description:
          "Understand WMV format: legacy, compatibility, and conversion guide. Learn its role in early streaming and how to convert for modern devices.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "mp3-meta-data":
      return {
        title: "Discover MP3 Format: How Audio Compression Changed Music",
        description:
          "Explore how MP3 revolutionized music with efficient compression and universal playback. Learn audio compression, bitrate trade-offs, and MP3's modern role.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "aac-meta-data":
      return {
        title: "AAC: The Audio Format That Powers Your Digital Life",
        description:
          "Understand AAC audio format: the modern MP3 successor. Learn why it delivers better sound efficiency for Spotify, YouTube, Apple Music, and streaming.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };
    case "flac-meta-data":
      return {
        title: "Master FLAC Audio Format: Lossless Sound Explained",
        description:
          "Master FLAC audio format: lossless sound explained. Learn its role in high-resolution audio, comparisons to MP3, and audiophile-quality streaming.",
        keywords:
          "3GP file format, 3GPP, mobile video format, 3GP vs MP4, convert 3GP to MP4, 3GP codec, H.263, AMR audio, legacy video formats, 3GP specification, TS 26.244, 3GP history, mobile multimedia, feature phone video",
      };

    // For Legal & Standard Pages

    case "privacy-policy":
      return {
        title: "Privacy Policy - SampleFiles.dev | Your Data Security",
        description:
          "Read the SampleFiles.dev privacy policy. Learn how we collect, use, and protect your data and information when you use our free file services.",
        keywords:
          "privacy policy, samplefiles privacy, data security, information collection, website privacy",
      };
    case "terms-of-service":
      return {
        title: "Terms of Service - SampleFiles.dev | User Agreement",
        description:
          "Review the Terms of Service for SampleFiles.dev. Understand the rules and guidelines for using our free sample files and online conversion tools.",
        keywords:
          "terms of service, user agreement, website terms, terms and conditions, legal agreement",
      };

    // For Company & Contact Pages

    case "about-us":
      return {
        title:
          "About Us - SampleFiles.dev | Free Sample Files & Tools for Developers",
        description:
          "Learn about SampleFiles.dev, our mission to provide free sample files and tools for developers, testers, and designers worldwide.",
        keywords:
          "about us, about samplefiles, our mission, free tools for developers, who we are",
      };
    case "contact-us":
      return {
        title: "Contact Us - SampleFiles.dev | Get in Touch",
        description:
          "Have questions or feedback? Contact the SampleFiles.dev team. We're here to help you with your sample file and development tool needs.",
        keywords:
          "contact us, get in touch, customer support, feedback, questions",
      };

    // ----------------- Default -----------------
    default:
      return {
        title: "Free Sample Files - Images, Videos & Documents Instantly",
        description:
          "Browse and download free sample files including images, videos, audio, and documents. Perfect for testing and development.",
        keywords:
          "sample files, free files download, test files, sample pdf, sample mp4, sample mp3, sample jpg",
        bodyText: "------",
      };
  }
};
